import { docsEn } from "./docs";
import { auditEn } from "./audit/en";
import type { Dictionary } from "./ru";

export const en: Dictionary = {
  reportReset: {
    "deleteArchive": "Delete archive",
    "deleteArchiveTitle": "Delete the reset archive?",
    "deleteArchiveText": "Reports for {{period}} will be permanently removed from the archive — you won't be able to download them again. The reset, its date and the history entry stay; orders and payments are not deleted.",
    "deleteArchiveSave": "If you still need the archive, download it before deleting:",
    "deleteArchiveConfirm": "Delete the archive for good?",
    "deleteArchiveConfirmText": "Deleting the archive can't be undone.",
    "archiveDeleted": "Archive deleted",
    "title": "Reset reports",
    "description": "Start with a clean slate: revenue and money in reports are counted from the date you choose. Nothing is deleted — reports for the past are saved to an archive.",
    "currentFrom": "Reports are counted from {{date}}",
    "currentAll": "Reports are counted from the very start",
    "currentHint": "Orders, payments, shifts and documents are not deleted. Reports for the past are in the archive — download it as Excel or PDF.",
    "start": "Reset reports",
    "history": "Reset history",
    "historyEmpty": "No resets yet",
    "colFrom": "Reports from",
    "colArchive": "Archive period",
   
    "colBy": "Who and when",
   
    "statusActive": "Active",
    "statusCancelled": "Undone",
    "archiveNone": "No data",
    "cancel": "Undo reset",
    "cancelTitle": "Undo the report reset?",
    "cancelText": "Reports will be counted {{since}} again. This reset's archive stays in the history.",
    "sinceDate": "from {{date}}",
    "sinceStart": "from the very start",
    "cancelled": "Reset undone — reports show past data again",
    "stepWhat": "What happens",
    "stepArchive": "Archive",
    "stepConfirm": "Confirmation",
    "stepOf": "Step {{n}} of 3 · {{name}}",
    "date": "Count reports again starting from",
    "dateHint": "Usually today or the first day of the month. Sales on that day stay in the new reports.",
    "resets": "Start from zero",
    "resetRevenue": "Revenue, payments, refunds and average check in reports",
    "resetFinance": "Finance: profit, expenses, purchases, write-offs and payroll in reports",
    "resetOther": "Dish sales, products, waiters, promotions, services and advanced reports",
    "keeps": "Stays the same",
    "keepMenu": "Menu, recipes, prices, stop list",
    "keepStock": "Warehouse and product stock",
    "keepDebts": "Customers and their debts, debts to suppliers",
    "keepStaff": "Staff, shifts, payroll",
    "keepJournal": "Orders, payments, cash shifts and documents in the journals — as they were",
    "archivePeriod": "The archive will contain reports for {{from}} — {{to}}",
    "archiveEmpty": "There are no reports before this date — the archive will be empty.",
    "archiveLimit": "The archive covers at most a year and no deeper than your plan's report history. The data itself stays in the database.",
    "archiveText": "Download the reports for the past period and keep them. You can download the archive again later from the reset history.",
    "archiveSaved": "I saved the archive or I don't need it",
    "archiveTitle": "Report archive",
    "branch": "Branch",
    "revenue": "Revenue",
    "orders": "Orders",
    "confirmText": "To confirm, type the word {{word}}.",
    "confirmWord": "RESET",
    "password": "Your password",
    "comment": "Comment",
    "commentPlaceholder": "For example: going live after training",
    "next": "Next",
    "back": "Back",
    "submit": "Reset reports",
    "finalTitle": "Reset reports?",
    "finalText": "All reports for every employee will start from {{date}}. No data is deleted; you can undo the reset in the history.",
    "done": "Reports reset — counting from {{date}}",
    "banner": "Reports are counted from {{date}} — earlier data is in the reset archive.",
    "bannerLink": "Reset reports",
  },
  nav: {
    "reportReset": "Reset reports",
    "menuPacks": "Menu packs",
    "help": "Help center",
    "stockRequests": "Stock requests",
    "purchaseRequests": "Purchase requests",
    "conversions": "Breakdown & assembly",
    "warehouses": "Warehouses",
    "transfers": "Transfers",
    "expiry": "Expiry dates",
    "production": "Production",
    site: "Website & QR menu",
    employees: "HR",
    positions: "Positions",
    workShifts: "Work shifts",
    payroll: "Payroll",
    tips: "Tips",
    myWork: "My account",
    audit: "Audit log",
    customers: "Customers",
    debts: "Debts",
    insights: "Cafe analytics", expenses: "Expenses", suppliers: "Suppliers", supplierReturns: "Supplier returns", purchases: "Purchases", writeoffs: "Write-offs",
    analytics: "Analytics", dashboard: "Dashboard", reports: "Reports",
    sales: "Sales", pos: "POS", posShort: "POS", orders: "Orders", kitchen: "Kitchen",
    venue: "Venue", branches: "Branches", tables: "Halls & tables",
    shifts: "Shifts & bookings", cashShifts: "Cash shifts", reservations: "Reservations",
    catalog: "Menu & stock", menu: "Menu", products: "Products", costing: "Costing", inventory: "Inventory", inventoryCounts: "Stock counts", notifications: "Notifications", security: "Security",
    staff: "Staff", users: "Employees", roles: "Roles & permissions",
    settings: "Settings", company: "Company", devices: "Terminals", subscription: "Subscription", support: "Support", fraud: "Abuse protection", sms: "SMS campaigns", services: "Services & rentals", banquets: "Banquets", promotions: "Promotions", deliveries: "Delivery", courier: "My deliveries", goals: "Goals & achievements", myGoals: "My goals", waiterZones: "Waiters by hall",
    kitchenStations: "Kitchen stations", more: "More",
  },
  common: {
    close: "Close",
    save: "Save", cancel: "Cancel", create: "Create", edit: "Edit", delete: "Delete", retry: "Retry", add: "Add",
    done: "Done", saved: "Changes saved", search: "Search…", logout: "Log out", logoutTitle: "Log out of your account?", logoutHint: "You will need to sign in again to continue.", profile: "Profile", branch: "Branch", allBranches: "All branches",
    active: "Active", inactive: "Disabled", blocked: "Blocked", soon: "Soon",
    locked: "Not in your plan", upgrade: "Upgrade", theme: "Theme", language: "Language",
    name: "Name", description: "Description", phone: "Phone", status: "Status", price: "Price", actions: "Actions",
    all: "All", no: "None", more: "More", filter: "Filter", moveUp: "Move up", moveDown: "Move down", hasErrors: "Has errors",
    nothingFound: "Nothing found", nothingFoundHint: "Try a different search", resetSearch: "Clear search", resetFilters: "Reset filters",
    deleteNamed: "Delete “{{name}}”?",
  },
  ui: {
    ok: "OK", confirm: "Confirm", actionFailed: "Action failed",
    typeToConfirmBefore: "Type", typeToConfirmAfter: "to confirm", dialog: "Dialog", close: "Close", clear: "Clear",
    showPassword: "Show password", hidePassword: "Hide password", select: "Select…", loadError: "Failed to load. Please try again.",
    create: "Create “{{q}}”", increase: "Increase", decrease: "Decrease", loading: "Loading", pages: "Pages",
    pageRange: "{{from}}–{{to}} of {{total}}", prevPage: "Previous page", nextPage: "Next page",
    selectAll: "Select all", selectRow: "Select", selectedCount: "Selected: {{count}}", clearSelection: "Clear selection",
    grams: "g", kilograms: "kg", weight: "Weight", perKg: "per 1 kg",
  },
  currencySymbols: { KGS: "som", KZT: "₸", UZS: "sum", RUB: "₽", TJS: "somoni" },
  errors: {
    IMPERSONATION_READ_ONLY: "The support session is read-only",
    INVOICE_PAID: "The invoice is paid and cannot be changed",
    DOWNGRADE_BLOCKED: "Usage exceeds the new plan limits",
    ADDON_UNAVAILABLE: "The add-on is not available on this plan",
    MENU_PACK_NOT_PURCHASED: "The menu pack is not paid yet — you can load it after the invoice is paid",
    TWO_FACTOR_INVALID: "Invalid verification code",
    CLOCK_IN_NOT_ALLOWED: "Clock-in is not allowed",
    WORK_SHIFT_OPEN: "The employee already has an open shift",
    PAYROLL_APPROVED: "The payroll is approved and cannot be changed",
    CREDIT_LIMIT_EXCEEDED: "Customer credit limit exceeded",
    DEPOSIT_REQUIRED: "The banquet is confirmed after the deposit is paid",
    DELIVERY_ADDRESS_OUT_OF_ZONE: "The address is outside the delivery zones",
    CUSTOMER_DEBT_OVERDUE: "The customer has an overdue debt — new credit is not allowed",
    CUSTOMER_BLOCKED: "Customer is blocked",
    CUSTOMER_PHONE_TAKEN: "A customer with this phone already exists",
    CASH_SHIFT_NOT_OPEN: "Cash shift is not open",
    CASH_INSUFFICIENT: "Not enough cash in the drawer",
    INSUFFICIENT_STOCK: "Not enough stock in the warehouse",
    APPROVAL_REQUIRED: "Manager approval required",
    APPROVAL_INVALID: "The approval does not match this action or has expired",
    APPROVAL_USED: "The approval has already been used",
    DISCOUNT_INVALID: "The discount exceeds the items that allow discounts",
    BRANCH_INACTIVE: "The branch is deactivated — changes are not allowed",
    DOCUMENT_POSTED: "A posted document cannot be changed or deleted",
    INVENTORY_COUNT_CLOSED: "The stock count is already posted or cancelled",
    PAYMENT_AMOUNT_INVALID: "Cashless payment exceeds the amount due",
    CUSTOMER_REQUIRED: "Select a customer to pay on credit",
    MODIFIERS_INVALID: "Check the modifier selection", TABLE_UNAVAILABLE: "Table is unavailable", ITEM_ALREADY_SENT: "The item was already sent to the kitchen — it can only be voided", ORDER_CLOSED: "Order is closed", ORDER_HAS_PAYMENTS: "The order has payments — cancel via refund only", NOTHING_TO_SEND: "No new items to send to the kitchen",
    NETWORK_ERROR: "No connection to the server. Check your internet", requestFailed: "Request failed", unknown: "Something went wrong. Please try again",
    code: "code: {{id}}…", actionFailed: "Action failed",
    limitTitle: "Plan limit reached", limitHint: "Limit: {{max}}. Upgrade your plan or add a package in “Subscription”.",
    planHint: "Open “Settings → Subscription” to renew or extend your plan.",
    conflictTitle: "Someone else has already changed this data", conflictHint: "We loaded the latest version — review it and repeat your change.",
    VALIDATION_ERROR: "Please check the highlighted fields", UNAUTHENTICATED: "Please sign in", TOKEN_EXPIRED: "Session expired",
    REFRESH_TOKEN_REUSED: "Session ended for security reasons. Please sign in again",
    DEVICE_REQUIRED: "PIN sign-in is only available on a registered terminal", DEVICE_REVOKED: "The terminal was disabled by an administrator",
    INVALID_CREDENTIALS: "Wrong login or password", FEATURE_NOT_IN_PLAN: "This feature is not in your plan", PLAN_LIMIT_REACHED: "Plan limit reached",
    SUBSCRIPTION_READ_ONLY: "Subscription is read-only", SUBSCRIPTION_SUSPENDED: "Subscription is suspended", PERMISSION_DENIED: "Insufficient permissions",
    BRANCH_ACCESS_DENIED: "No access to this branch", NOT_FOUND: "Not found", VERSION_CONFLICT: "The data has changed. Refresh the page",
    DUPLICATE: "This record already exists", SLUG_TAKEN: "This address is already taken", ENTITY_IN_USE: "The record is in use and cannot be deleted",
    ACCOUNT_LOCKED: "Account temporarily locked", PIN_LOCKED: "PIN sign-in temporarily locked",
    RATE_LIMITED: "Too many attempts. Try again later", INTERNAL_ERROR: "Internal server error",
    UNIT_CONVERSION_UNDEFINED: "The unit can't be converted to the product unit — set the product density",
    RECIPE_CYCLE: "A semi-finished product can't contain itself (or nesting is deeper than 5 levels)",
    RECIPE_VERSION_PUBLISHED: "A published recipe version can't be changed — create a new one",
    MENU_ITEM_UNAVAILABLE: "Item is not available for sale", TABLE_OCCUPIED: "Table is occupied",
    FILE_TOO_LARGE: "File is too large (max 10 MB)", FILE_TYPE_NOT_ALLOWED: "Allowed images: JPEG, PNG, WebP, AVIF, HEIC",
    SERVICE_UNAVAILABLE: "Service temporarily unavailable",
    SHIFT_ALREADY_OPEN: "A shift is already open on this terminal", SHIFT_CLOSED: "The shift is already closed",
    CURSOR_EXPIRED: "Terminal data is outdated — full reload required", BATCH_TOO_LARGE: "Data batch is too large", OPEN_ORDERS_EXIST: "There are open orders — close them before changing currency", TOTALS_MISMATCH: "Order total does not match the server calculation", TERMINAL_REVOKED: "The terminal was disconnected by an administrator", REFUND_EXCEEDS_PAID: "Refund amount exceeds the paid amount", ORDER_NOT_PAID: "The order has no payments to refund",
    INVALID_STATUS_TRANSITION: "This action is not available in the current status — refresh the page", BUSINESS_RULE: "The action is not possible", QUOTA_EXCEEDED: "Quota exhausted — add a pack in «Subscription»",
    row: "Row {{n}}",
    detail: {
      stock: "{{product}}: {{available}} in stock, {{required}} needed", stockAt: "{{product}} ({{warehouse}}): {{available}} in stock, {{required}} needed",
      creditOff: "Paying on credit is not allowed for this customer", credit: "Limit {{limit}}, current debt {{balance}}, new debt {{amount}}",
      cash: "Cash in drawer {{expected}}, needed {{amount}}", due: "Left to pay {{due}}", depositLeft: "Available from the deposit {{available}}",
      refund: "You can refund at most {{available}}", deposit: "Required {{required}}, paid {{paid}}", discount: "Total of items that allow a discount — {{base}}",
      unavailable: "Unavailable: {{items}}", permission: "Permission required: {{perms}}. Contact your administrator", retry: "Try again in {{min}} min",
      quota: "Needed {{needed}}, remaining {{remaining}}", unit: "{{product}}: «{{unit}}» cannot be converted to «{{base}}»", limit: "Plan limit: {{max}}",
    },
  },
  validation: {
    purchaseLine: "Pick a product or type a name", purchaseDocNotFound: "Purchase not found in this branch",
    geoLat: "Enter the latitude", geoLng: "Enter the longitude", geoLatRange: "Latitude must be between −90 and 90", geoLngRange: "Longitude must be between −180 and 180", geoPair: "Enter both latitude and longitude",
    socialWhatsapp: "WhatsApp number in the format +996XXXXXXXXX or a link", socialHandle: "A link or account name (@name)",
    lossRequired: "Enter the loss", lossMin: "Must be zero or more", lossOnlyReceipt: "Loss is only for purchases", lossPercentMax: "Loss must be under 100%", lossQtyMax: "Loss must be less than the quantity",
    bulkPick: "Select at least one record", bulkMax: "No more than 500 records at a time", bulkWhat: "Choose what to change", intOnly: "Enter a whole number", nonZeroChange: "The change cannot be zero", bulkPercent: "Percent — from −90 to 500",
    codeRequired: "Enter the code from the email",
    code6: "The code is 6 digits", codeWrong: "Wrong code", codeExpired: "The code has expired or was not requested — send a new one",
    codeTooMany: "Too many wrong attempts — send a new code", resetLinkExpired: "The link is invalid or expired — request a reset again",
    nothingToPay: "Nothing to pay",
    tipsPeriodTaken: "Tips for this period are already distributed",
    tipsEmpty: "No tips in this period",
    noShiftParticipants: "No employees with shifts in this period",
    dismissSelf: "You cannot dismiss yourself",
    positionNotFound: "Position not found",
    debtNotFound: "Open debt not found",
    customerNotFound: "Customer not found",
    diffReason2: "Describe the reason for the difference",
    periodMax3: "Period must not exceed 3 months",
    periodMax2: "Period must not exceed 2 months",
    endAfterStart2: "End must be after start",
    nonZero: "Amount cannot be 0",
    diffReason: "Describe the reason for the difference",
    selectProduct: "Select an ingredient", expenseCategory: "Select a category", amountPositive: "Amount must be greater than zero", qtyRequired: "Enter a quantity", qtyPositive: "Quantity must be greater than zero", unknownUnit: "Unknown unit", reasonSelect: "Select a reason", amountRequired: "Enter an amount", linesRequired: "Add at least one line", productNotFound: "Product not found",
    refundPositive: "Refund amount must be greater than 0",
    reasonRequired: "Enter a reason",
    refundTarget: "Choose a payment or refund method",
    dateFormat: "Date format YYYY-MM-DD",
    periodOrder: "Period end is before its start",
    periodMax: "Period must not exceed one year",
    endAfterStart: "End must be after start",
    paymentPositive: "Payment amount must be greater than 0",
    reasonComment: "Describe the reason", tableRequired: "Select a table for a dine-in order",
    required: "Required field", minChars: "At least {{n}} characters", maxChars: "At most {{n}} characters", min2: "At least 2 characters",
    invalidId: "Invalid identifier", phoneFormat: "Phone in the format +996XXXXXXXXX", invalidEmail: "Invalid email",
    slugChars: "Latin letters, digits and hyphens only", pinFormat: "PIN — 4–6 digits", passwordMin: "Password — at least 10 characters",
    siteSlugFormat: "Subdomain: 3–40 characters, Latin letters, digits and hyphens", siteSlugReserved: "This is a reserved address — choose another subdomain",
    passwordMax: "Password — at most 128 characters", passwordChars: "Password must contain letters and digits",
    currencyCode: "ISO 4217 currency code", countryCode: "ISO 3166-1 country code", moneyInteger: "Amount must be an integer (minor units)",
    invalidQty: "Invalid quantity", unknownTz: "Unknown time zone", timeFormat: "Format HH:MM",
    formatsRequired: "Select at least one format", taxId: "Tax ID — 10–14 digits", pct: "From 0 to 99.99", sku: "Latin letters, digits, . _ - (up to 64)",
    barcode: "Barcode — 6–14 digits", invalidPrice: "Invalid price", oldPrice: "Old price must be higher than the current one",
    productRequired: "Select a stock product for goods", oneDefaultVariant: "Only one default variant allowed",
    duplicateVariants: "Variant names are repeated", modifiersRequired: "Add at least one modifier",
    maxGteMin: "Maximum must not be less than minimum", singleMax: "For single choice the maximum is 1",
    minTooHigh: "Minimum exceeds the number of active modifiers", modifierQty: "Set the write-off quantity for a modifier with a product",
    positive: "Greater than 0", loginFormat: "Enter an email or a phone in the format +996…", loginRequired: "Enter an email or phone",
    passwordRequired: "Enter your password", ingredientRequired: "Select a product or semi-finished product",
    passwordNeedsContact: "Password sign-in requires an email or phone", passwordOrPin: "Set a password or PIN",
    activationCode: "Activation code — 8 characters", assignRole: "Assign at least one role", invalidDate: "Invalid date",
    acceptTerms: "You must accept the terms of service", seatsMin: "At least 1 seat", numberRequired: "Enter a number", copyFactor: "Factor from 0.01 to 100", copyTargets: "Choose where to copy",
    goalTargetPositive: "Target must be greater than zero", goalTargetInteger: "Target must be a whole number", goalDates: "Set the goal dates", goalItemOnly: "An item or category is only for a dishes-sold goal", goalItemOrCategory: "Choose an item or a category",
  },
  shell: {
    sections: "Sections", home: "Home", logo: "Logo", skipToContent: "Skip to content", workScreens: "Work screens", hideLabels: "Hide labels", showLabels: "Show labels",
  },
  guards: {
    noAccess: "Insufficient permissions",
    noAccessHint: "Ask the owner or manager to grant you access to this section.",
    featureLocked: "The “{{feature}}” feature is not included in your plan. Add the extra service or change your plan.",
    soonTitle: "{{title}} — in development",
    soonHint: "This section will arrive in one of the upcoming updates according to the rollout plan.",
  },
  auth: {
    twoFactorTitle: "Verification code",
    twoFactorHint: "Open your authenticator app (Google Authenticator, etc.) and enter the 6-digit code.",
    twoFactorBackupHint: "Enter one of the backup codes saved when you enabled protection. Each code works once.",
    twoFactorCodeLabel: "Code from the app",
    twoFactorBackupLabel: "Backup code",
    twoFactorCodeFormat: "The code is 6 digits",
    twoFactorBackupFormat: "Backup code is 8 characters, e.g. abcd-efgh",
    twoFactorConfirm: "Sign in",
    twoFactorUseBackup: "No access to the app? Use a backup code",
    twoFactorUseApp: "Enter a code from the app",
    twoFactorWrong: "Wrong code",
    twoFactorExpired: "Time to enter the code has expired — sign in again",
    forgotTitle: "Reset password",
    forgotDescription: "Enter your email and we will send a link to set a new password.",
    forgotSentTitle: "Check your inbox",
    forgotSent: "If {{email}} is registered, a link is on its way. It is valid for 30 minutes.",
    forgotAgain: "Request a new link",
    backToLogin: "Back to sign in",
    forgotSend: "Send link",
    resetTitle: "New password",
    resetDescription: "Choose a new password. You will need to sign in again on all devices.",
    resetNoToken: "The link is incomplete or expired. Request a new one.",
    newPassword: "New password",
    passwordRules: "At least 10 characters, letters and digits",
    resetSave: "Save password",
    resetDone: "Password changed — sign in with the new password",
    emailField: "Email",
    loginTitle: "Sign in",
    loginDescription: "Orders, kitchen, stock and analytics of your venue in one place.",
    terms: "Terms of use",
    loginField: "Email or phone",
    loginPlaceholder: "owner@cafe.kg or +996…",
    password: "Password",
    passwordPlaceholder: "Enter password",
    forgot: "Forgot password?",
    forgotHint: "Password recovery is coming in the next update. Please contact the venue owner.",
    signIn: "Sign in",
    noAccount: "No account?",
    chooseCompany: "Choose a company",
    chooseCompanyHint: "This login is used in several venues",
    registerTitle: "Connect your venue",
    registerDescription: "14 days of full access for free. No card required.",
    haveAccount: "Already have an account?",
    companyName: "Venue name",
    companyNamePlaceholder: "Morning Coffee",
    yourName: "Your name",
    yourNamePlaceholder: "Aibek Asanov",
    phoneHint: "For notifications and account recovery",
    passwordHint: "At least 10 characters, letters and digits",
    newPasswordPlaceholder: "Create a password",
    acceptBefore: "I accept the",
    acceptLink: "terms of service",
    acceptAfter: "and the personal data processing policy",
    startFree: "Start for free",
    registerCodeTitle: "Confirm your email",
    registerCodeDescription: "We sent a 6-digit code to {{email}}. It is valid for 10 minutes.",
    registerCodeLabel: "Code from the email",
    registerCodeHint: "Didn't get it? Check the Spam and Promotions folders.",
    registerConfirm: "Confirm",
    registerResend: "Send the code again",
    registerResendIn: "Send again in {{sec}} s",
    registerCodeSent: "Code sent to {{email}}",
    registerChangeData: "Edit details",
    forgotSelfSent: "A link to set a new password was sent to {{email}}",
    forgotNoEmail: "You have no email on file — ask an administrator to set a new password in “Staff”.",
  },
  terminal: {
    mode: "Mode",
    modeLogin: "Sign in",
    modeClock: "Clock in/out",
    clockTitle: "Clock in and out",
    clockHint: "Enter your PIN — clock-in or clock-out is recorded automatically",
    clockedIn: "{{name}}: clocked in",
    clockedOut: "{{name}}: clocked out, worked {{h}}",
    mark: "Record",
    activateTitle: "Terminal activation",
    activateDescription: "Enter the one-time code from “Settings → Terminals”.",
    code: "Activation code",
    activate: "Activate",
    wrongPin: "Wrong PIN",
    terminal: "Terminal",
    pinTitle: "PIN sign-in",
    pinHint: "Enter your PIN to start your shift",
    digitsEntered: "Digits entered: {{count}}",
    erase: "Erase",
    managerTitle: "Manager sign-in",
    managerHint: "A PIN is only needed to send an order back to the kitchen. Cooks use the kitchen screen without signing in.",
    backToScreen: "Back to screen",
    appDevice: "This is a Kafe Coco register — pair it in the Kafe Coco app with a code from “Terminals”, not in the browser.",
    unsupported: "This device type doesn't work in the browser yet. Create a register, kitchen screen or order-ready screen.",
    screenFailed: "The screen didn't start",
    revoked: "The device was disconnected — activate it again with a code from “Terminals”.",
  },
  dashboard: {
    hello: "Hello, {{name}}!",
    sectionsHint: "Tap a section to see its pages",
    pages: "Pages: {{count}}",
  },
  currencies: { KGS: "Kyrgyz som", KZT: "tenge", UZS: "Uzbek sum", RUB: "ruble", TJS: "somoni", USD: "US dollar", EUR: "euro" },
  formats: { dine_in: "Dine-in", takeaway: "Takeaway", delivery: "Delivery", self_service: "Self-service" },
  branches: {
    description: "Company points of sale: addresses, opening hours, service formats.",
    add: "Add branch", create: "Create branch", newTitle: "New branch", editTitle: "Branch “{{name}}”",
    searchPlaceholder: "Name or city", empty: "No branches yet",
    deleteTitle: "Delete branch “{{name}}”?", deleteHint: "The branch will be hidden from all lists. Sales history is kept.", deleted: "Branch deleted",
    tabMain: "General", tabHours: "Opening hours",
    namePlaceholder: "Central", slug: "URL address (slug)", slugHint: "Used in the website address and QR menu",
    city: "City", cityPlaceholder: "Bishkek", address: "Address", addressPlaceholder: "77 Kievskaya St.",
    timezone: "Time zone", currency: "Currency", dayCutoff: "Business day cutoff", dayCutoffHint: "Sales before this time count toward the previous day",
    formats: "Service formats", formatsShort: "Formats", tzCurrency: "Zone / currency", working: "Open",
    isActive: "Branch is operating", isActiveHint: "A disabled branch doesn't accept orders and doesn't count toward the plan limit",
    hoursError: "Check the time: format HH:MM", dayOff: "Day off",
    opens: "{{day}}: opens", closes: "{{day}}: closes",
    overnightHint: "Closing earlier than opening means working past midnight (e.g. 10:00 — 02:00).",
    days: { mon: "Monday", tue: "Tuesday", wed: "Wednesday", thu: "Thursday", fri: "Friday", sat: "Saturday", sun: "Sunday" },
  },
  users: {
    description: "ERP access by password, terminal access by PIN. Roles are assigned per branch.",
    add: "Add employee", newTitle: "New employee", added: "Employee added",
    searchPlaceholder: "Name, phone or email", allStatuses: "All statuses", activeMany: "Active", blockedMany: "Blocked",
    employee: "Employee", you: "(you)", contacts: "Contacts", roles: "Roles", role: "Role", login: "Sign-in", lastLogin: "Last sign-in",
    allBranchesLower: "all branches",
    status: { active: "Active", blocked: "Blocked", invited: "Invited" },
    notFound: "No one found", empty: "No employees yet",
    resetPin: "Reset PIN", resetPassword: "Reset password",
    sendResetLink: "Send a password reset link", resetLinkSent: "A password reset link was sent to {{email}}",
    emailCodeLabel: "Code from the employee's email", emailCodeHint: "Click “Send code” — the code goes to this email. Ask the employee to tell you the code.", sendCode: "Send code", resendIn: "Again in {{sec}} s", codeSent: "Code sent to {{email}}",
    block: "Block", blockTitle: "Block {{name}}?", blockHint: "All of the employee's sessions will end immediately and sign-in will be impossible.",
    blocked: "Employee blocked", unblock: "Unblock", unblocked: "Employee unblocked",
    deleteTitle: "Delete {{name}}?", deleteHint: "The employee will disappear from lists; their action history is kept.", deleted: "Employee deleted",
    fullName: "Full name", fullNamePlaceholder: "Asel Toktogulova",
    access: "Sign-in method", accessHint: "PIN — quick sign-in on a branch terminal. Password — ERP sign-in (counts toward the plan's user limit).",
    accessOptions: { pin: "PIN only", password: "Password (ERP)", both: "Password and PIN" },
    pin: "PIN code", pinHint: "4–6 digits, unique within the company",
    chooseRole: "Select a role", chooseBranch: "Select a branch", checkRoles: "Check the roles", assignRole: "Assign at least one role",
    addRole: "Add role", removeRole: "Remove role",
    newPin: "New PIN", newPassword: "New password", pinLabel: "PIN code (4–6 digits)", passwordLabel: "Password (≥ 10 characters, letters and digits)",
    pinChanged: "PIN changed", passwordChanged: "Password changed, all of the employee's sessions have ended",
  },
  notifications: {
    bell: "Notifications",
    bellUnread: "Notifications: {{n}} new",
    title: "Notifications",
    settings: "Settings",
    readAll: "Mark all as read",
    new: "new",
    empty: "No notifications yet",
    emptyHint: "Shift summaries, stock alerts, refunds and QR orders will appear here.",
    settingsTitle: "Notifications",
    settingsDescription: "Choose what to receive and where. Everything important is also in the bell in the header.",
    telegramHint: "Connect your own Telegram: the {{bot}} bot will send the notifications available to your role.",
    telegramLinked: "Connected {{user}}",
    telegramNotLinked: "Not connected",
    telegramNotInPlan: "Telegram notifications are available on the Pro plan or with the Telegram add-on.",
    telegramConnect: "Connect Telegram",
    telegramRelink: "Connect another chat",
    telegramUnlink: "Disconnect",
    telegramUnlinkTitle: "Turn off Telegram notifications?",
    telegramOpened: "Open Telegram and press Start in the bot chat",
    refresh: "Refresh status",
    linkedAt: "Connected {{at}}",
    channels: "Channels",
    channelTelegram: "Messages from the bot",
    channelEmail: "Emails to {{email}}",
    noEmail: "You have no email set",
    dailyReport: "Daily report",
    dailyReportHint: "Evening summary for your branches: revenue, checks, top dishes, write-offs.",
    types: "What to send",
    typesHint: "Turn on the notifications you need and choose where to send them. The list depends on your role permissions.",
    typesEmpty: "No notifications for your role",
    typesEmptyHint: "Notifications will appear once you are granted permissions (e.g. POS, inventory or analytics).",
    fromCoca: "From Coca",
    whatsNew: "New in Coca",
    open: "Open",
    typeLabels: {
      "stock_request": "Stock requests from branches",
      purchase_request: "New purchase requests",
      purchase_decision: "My purchase requests: decision and purchase",
      "stock_expiring": "Expiry dates: expired and expiring",
      stock_low: "Products running low",
      shift_closed: "Cash shift closed (Z summary)",
      refund_created: "Refunds",
      report_daily: "Daily report",
      order_qr: "New QR orders",
      table_call: "Waiter call and bill request (QR)",
      supplier_due: "Supplier payments (overdue and due today–tomorrow)",
      support_reply: "Support replies to your requests",
      support_access: "Coca support requests to access your account",
      fraud_alert: "Suspicious staff actions",
      sms_quota: "SMS quota: 80% and 100%",
      goal_achieved: "Team goals reached",
      achievement_earned: "My goals and achievements",
      waiter_table: "My tables: a table assigned or handed over",
      platform_message: "Messages from Coca",
      platform_update: "New Coca features",
    },
  },
  security: {
    title: "Security",
    description: "Sign-in protection and active sessions.",
    twoFactor: "Two-factor authentication",
    twoFactorHint: "Besides the password, signing in requires a code from the app on your phone.",
    on: "Enabled",
    off: "Disabled",
    recommend: "Recommended for owners and administrators: even if the password leaks, nobody can sign in without your phone.",
    enable: "Enable",
    enableTitle: "Enable two-factor authentication",
    enableHint: "Scan the QR code in your authenticator app and enter the code it shows.",
    qrAlt: "QR code for the authenticator app",
    manualKey: "Or enter the key manually:",
    enabledToast: "Two-factor authentication enabled",
    enabledAt: "Enabled {{at}}. Backup codes left: {{n}}.",
    fewCodes: "Almost no backup codes left — generate new ones.",
    regen: "New backup codes",
    regenTitle: "New backup codes",
    regenHint: "Old codes will stop working. Enter a code from the app.",
    disable: "Disable",
    disableTitle: "Disable two-factor authentication?",
    disableHint: "Enter your password and a code from the app (or a backup code).",
    disabledToast: "Two-factor authentication disabled",
    codeOrBackup: "App code or backup code",
    backupTitle: "Backup codes",
    backupHint: "Keep them somewhere safe: you need them if your phone is lost. Each code is one sign-in. They will not be shown again.",
    copy: "Copy",
    copied: "Codes copied",
    download: "Download",
    saved: "I have saved the codes",
    sessions: "Active sessions",
    sessionsHint: "Where your account is signed in.",
    current: "this one",
    lastUsed: "active {{at}}",
    unknownDevice: "Unknown device",
    revoke: "End",
    revokeTitle: "End this session?",
    logoutAll: "Sign out everywhere",
    logoutAllTitle: "Sign out on all devices?",
    logoutAllHint: "All sessions, including this one, will be ended.",
  },
  approval: {
    descriptionVoid: "The item is already in the kitchen — only a manager can remove it. Ask them to enter their PIN.",
    title: "Manager approval required",
    description: "{{action}}: {{value}} exceeds your limit ({{limit}}). Ask a manager to enter their PIN.",
    confirm: "Approve",
    pin: "Manager PIN",
    pinFormat: "PIN is 4–6 digits",
    wrongPin: "Wrong PIN",
    noRight: "This employee cannot approve this action",
    self: "Only another employee can approve",
    hint: "The approval is single-use and valid for 2 minutes. Both employees are recorded in the audit log.",
    actions: {
      order_discount: "Discount",
      order_void: "Item removal",
      payment_refund: "Refund",
      stock_writeoff: "Write-off",
      cash_cash_out: "Cash withdrawal",
    },
  },
  roles: {
    limitsTitle: "Limits without approval",
    limitsHint: "Above the limit a manager approves with their PIN. Empty means no limit.",
    limitEmpty: "Empty — no limit",
    limits: {
      orders_discount: "Discount up to",
      payments_refund: "Refund up to",
      stock_documents_create: "Write-off up to",
      cash_shifts_cash_out: "Cash withdrawal up to",
    },
    description: "A set of employee permissions. You can't grant a role with more permissions than your own.",
    newTitle: "New role", created: "Role created", updated: "Role updated", deleted: "Role deleted", deleteTitle: "Delete role “{{name}}”?",
    empty: "No roles", system: "System", systemHint: "System role — a platform template; you can change its permissions for your company",
    stats: "Permissions: {{perms}} · Employees: {{users}}", scopeCompany: "Whole company",
    ownerReadOnly: "The owner role can't be edited", ownerReadOnlyHint: "The owner always has full access, including the subscription.",
    namePlaceholder: "Senior cashier", scope: "Applies to", scopeFixed: "The role scope is set on creation",
    scopeHint: "Whole business — for an accountant or auditor; branch — for a cashier or cook",
    inBranch: "In a branch", inCompany: "Across the company", permissions: "Permissions",
    findSection: "Find a section", selectedCount: "Permissions selected: {{count}}",
  },
  systemRoles: {
    owner: "Owner", company_admin: "Company administrator", branch_manager: "Branch manager", accountant: "Accountant",
    cashier: "Cashier", waiter: "Waiter", cook: "Cook", auditor: "Auditor", courier: "Courier",
  },
  permResources: {
    report_resets: "Report reset",
    purchase_requests: "Purchase requests",
    waiter_zones: "Waiters by hall",
    goals: "Goals & achievements",
    "stock_transfers": "Transfers",
    "production": "Production",
    tips: "Tips",
    dashboard: "Dashboard", pos: "POS", orders: "Orders", tables: "Tables", halls: "Halls", kitchen: "Kitchen", menu: "Menu",
    stop_list: "Stop list", recipes: "Recipes", costing: "Costing", warehouses: "Warehouses", stock: "Stock levels",
    stock_documents: "Stock documents", inventory_counts: "Stocktaking", suppliers: "Suppliers", supplier_payments: "Supplier payments", customers: "Customers", debts: "Debts",
    payments: "Payments", cash_shifts: "Cash shifts", reservations: "Reservations", employees: "Employees", work_shifts: "Work shifts", payroll: "Payroll",
    expenses: "Expenses", analytics: "Analytics", reports: "Reports", settings: "Settings", branches: "Branches",
    users: "Users", roles: "Roles", devices: "Terminals", audit: "Audit", subscription: "Subscription", support: "Support", fraud: "Abuse protection", sms: "SMS campaigns", services: "Services & rentals", banquets: "Banquets", promotions: "Promotions", deliveries: "Delivery",
  },
  permActions: {
    "receive": "Receiving",
    "complete": "Completing output",
    adjust: "Adjustment", write_off: "Write-off", x_report: "X report", calculate: "Calculation", pay: "Payout", grant_access: "Support access",
    view: "View", create: "Create", update: "Edit", delete: "Delete", manage: "Manage", approve: "Approve",
    cancel: "Cancel", refund: "Refund", discount: "Discounts", void: "Void", reopen: "Reopen", transfer: "Transfer",
    merge: "Merge", split: "Split", price_override: "Price override", credit_sale: "Sale on credit", print: "Print",
    export: "Export", post: "Post", unpost: "Unpost", open_shift: "Open shift", close_shift: "Close shift",
    cash_in: "Cash in", cash_out: "Cash out", finance: "Finance", assign: "Assign",
  },
  venue: {
    title: "Venue “{{name}}”: currency and tax", description: "Current branch settings for Kafe Coco terminals — changes reach terminals within seconds.",
    currency: "Currency", currencyHint: "Can be changed only when there are no open orders", symbolPosition: "Currency symbol", before: "Before amount", after: "After amount",
    taxRate: "Tax rate, %", taxIncluded: "Tax included in price", taxIncludedHint: "Turn off if tax is added on top of the receipt total",
  },
  company: {
    description: "Company details and default regional settings for new branches.",
    legalName: "Legal name", legalNamePlaceholder: "LLC “…”", taxId: "Tax ID",
    defaultLocale: "Default language", baseCurrency: "Base currency", baseCurrencyHint: "Changed via support — affects reports",
  },
  geo: {
    tab: "On the map",
    cardTitle: "Contacts and map locations",
    cardDescription: "Guests find you on the “Nearby” page of the Coca website: your locations on the map, contacts and current promotions. Your website gets a “Directions” button.",
    openNearby: "Open “Nearby”",
    onMap: "On the map",
    notOnMap: "Not set",
    set: "Set on the map",
    noAddress: "No address",
    modalTitle: "{{name}} on the map",
    branchHint: "Click the map or drag the pin to your entrance. Guests see the point on the “Nearby” page of the Coca website and in the “Directions” button on your website.",
    contactsHint: "Phone, email and social networks (Instagram, WhatsApp, Telegram…) for guests are set in “Website & QR menu”.",
    contactsLink: "Fill in contacts",
    findAddress: "Find by address",
    myLocation: "My location",
    clear: "Remove point",
    noPoint: "No point set",
    hint: "Click the map to place the pin",
    mapAria: "Map: choose the location",
    notFound: "Address not found — place the pin on the map manually",
    denied: "Could not get your location — allow geolocation or place the pin manually",
    invalid: "The point is invalid — place the pin again",
  },

  subscription: {
    description: "Plan, limits and enabled features. Payment and plan changes go through the platform manager (online payment is coming later).",
    trialLeft: "Trial: {{count}} days left", trialHint: "When it ends, choose a plan to keep working without limits.",
    payHint: "Pay the invoice to restore full access. POS sales keep working.",
    plan: "{{plan}} plan", features: "Features", featuresHint: "Checked ones are available in your plan", available: "Available", unavailable: "Unavailable",
    status: {
      trialing: "Trial", active: "Active", past_due: "Awaiting payment", read_only: "Read-only", suspended: "Suspended",
      cancelled: "Cancelled", expired: "Expired", archived: "Archived",
    },
    limits: {
      branches: "Branches", terminals: "Terminals", users: "Users with password", warehouses: "Warehouses", menu_items: "Menu items",
      ai_requests: "Coca AI requests this month",
      storage_gb: "Storage, GB", report_history_days: "Report history, days", api_rps: "API, requests/s",
    },
  },
  features: {
    core: {
      pos: "Checkout and orders", menu: "Menu", tables: "Hall and tables", kds: "Kitchen screen", inventory_basic: "Basic inventory",
      recipes: "Recipes and costing", customers: "Customers", debts: "Customer debts", staff: "Employees and shifts",
      payroll_basic: "Basic payroll", analytics_basic: "Basic analytics", qr_menu: "QR menu", website: "Venue website",
    },
    addon: {
      qr_ordering: "QR ordering", online_payments: "Online payments", inventory_pro: "Inventory (advanced)", procurement: "Procurement",
      production: "Production", payroll_pro: "Payroll (advanced)", finance: "Finance", loyalty: "Guest bonuses and discounts",
      promotions_pro: "Promotions (advanced)", reservations: "Table reservations", banquets: "Banquets", services: "Services and rentals",
      delivery: "Delivery", aggregators: "Delivery services (Glovo etc.)", telegram: "Telegram bot", sms: "SMS campaigns", analytics_pro: "Reports (advanced)",
      fraud: "Abuse protection", reviews: "Guest reviews", custom_domain: "Your own website address", api_access: "Connecting other software", offline_mode: "Working without internet",
      desktop: "Checkout app for computer", fiscal: "Fiscal receipts", accounting_export: "Export to 1C", ai: "Smart assistant",
      white_label: "White label", priority_support: "Priority support",
    },
  },
  devices: {
    download: "Download the POS app:", platforms: { windows: "Windows", macos: "macOS" },
    where: "Where the POS runs", whereBrowser: "In the browser", whereApp: "Desktop app",
    pair: "Pair POS terminal", pairTitle: "Pair a POS terminal", pairHint: "Open the POS app on the computer and enter the code:",
    pairOneTime: "One-time code. After pairing the terminal loads this branch's menu and tables; staff sign in with their PIN.",
    description: "Cash registers, kitchen screens and waiter tablets. PIN sign-in works only on registered devices.",
    add: "Add terminal", newTitle: "New terminal", getCode: "Get code", namePlaceholder: "Front register",
    type: "Device type", typeShort: "Type", activity: "Activity",
    empty: "No terminals yet", emptyHint: "Add a register or kitchen screen and activate the device with a one-time code.",
    reset: "New code", resetTitle: "Issue a new code for “{{name}}”?", resetHint: "The device will lose access immediately and its sessions will end. Enter the new code on the same device — its name, branch and register number are kept.", resetCodeTitle: "New code for “{{name}}”",
    deleteTitle: "Delete “{{name}}”?", deleteHint: "The terminal disappears from the list and loses access immediately; its slot in the limit is freed. Orders and the log are kept.", deleted: "Terminal deleted",
    revoke: "Disable", revokeTitle: "Disable “{{name}}”?", revokeHint: "The device will lose access immediately; all sessions on it will end.", revoked: "Terminal disabled",
    openBefore: "On the device “{{name}}”, open", openAfter: "and enter the code:",
    codeCopied: "Code copied", copyCode: "Copy code", codeValid: "Code valid for {{time}}", codeExpired: "Code expired — issue a new one via “⋯ → New code” on the terminal",
    oneTimeHint: "The code is single-use. After activation, employees sign in on the device with their PIN.",
    oneTimeHintScreen: "The code is single-use. After activation the screen opens by itself — no PIN needed.",
    access: { pin: "Employees sign in with their PIN and work with their own permissions.", screen: "Works without a PIN: the screen opens right after activation.", app: "Paired in the Kafe Coco app on the register computer." },
    status: { pending: "Awaiting activation", active: "Active", revoked: "Disabled" },
    types: {
      pos: "Register (POS)", kds: "Kitchen screen (KDS)", waiter: "Waiter", kiosk: "Self-service kiosk", customer_display: "Customer display",
      ready_screen: "Order-ready screen", printer_bridge: "Print server", desktop: "Register (POS)", courier: "Courier",
    },
  },
  menu: {
    description: "Items, categories, modifiers and stop list. Changes show up on registers immediately.",
    tabItems: "Items", tabCategories: "Categories", tabModifiers: "Modifiers", tabStop: "Stop list",
    notForSale: "Not for sale", stop: "Stopped", remaining: "{{count}} left", hiddenInBranch: "Hidden in branch", priceFrom: "from {{price}}",
    pricePerKg: "{{price}}/kg",
    searchItems: "Search by name or SKU", addItem: "Add item", noItems: "No menu items yet",
    createCategoryFirst: "Create a category first", createCategoryFirstHint: "For example “Coffee”, “Hot dishes”, “Desserts” — on the “Categories” tab.",
  },
  bulk: {
    select: "Select", done: "Done", selectAll: "Select all", selectPage: "Select all on this page", change: "Change",
    onSale: "Put on sale", offSale: "Take off sale", showPublic: "Show in public menu", hidePublic: "Hide from public menu",
    allowDiscount: "Allow discount", denyDiscount: "Disallow discount", move: "Move to category…", price: "Change price…",
    fromStop: "Back on sale", setPortions: "Set portions left", stopTitle: "Stop: {{count}} items",
    priceTitle: "Price: {{count}} items", priceUp: "Increase", priceDown: "Decrease", priceMode: "How to change", pricePercent: "By percent", priceAmount: "By amount",
    priceHint: "Variant prices change the same way. Price never goes below 0; the old price is cleared if it is no longer above the new one.",
    moveTitle: "Move {{count}} items", category: "Category",
    showCategories: "Show", hideCategories: "Hide", channelsTitle: "Sales channels: {{count}} categories", keep: "Keep", show: "Show", hide: "Hide",
    deleteItemsTitle: "Delete items ({{count}})?", deleteItemsHint: "Items disappear from registers and the site; sales history is kept.",
    deleteCategoriesTitle: "Delete categories ({{count}})?", deleteCategoriesHint: "Only empty categories are deleted. If any contains items, nothing is deleted.",
    updated: "Updated: {{count}}", deleted: "Deleted: {{count}}", stopped: "On stop: {{count}}", unstopped: "Back on sale",
  },
  stop: {
    hint: "Applies to the current branch (selected in the top bar). Registers and the QR menu hide the item immediately.",
    add: "Put on stop", added: "Item is on the stop list", portionsLeft: "Portions left: {{count}}",
    item: "Item", state: "State", since: "Since", return: "Restore", backOnSale: "Back on sale",
    empty: "Stop list is empty", emptyHint: "All items are available for sale.",
    portions: "Portions left", portionsHint: "Empty — completely sold out. A number — sold until it runs out",
  },
  categories: {
    title: "Category", newTitle: "New category", image: "Category image", namePlaceholder: "Coffee", slug: "Address (slug)",
    parent: "Parent category", parentHint: "Up to 3 nesting levels", topLevel: "Top level",
    channels: "Where to show", channel: { pos: "Register", qr: "QR menu", website: "Website", delivery: "Delivery" }, visible: "Category is visible",
    deleteTitle: "Delete category “{{name}}”?", deleted: "Category deleted", itemsCount: "{{count}} items", hidden: "Hidden",
    subcategory: "Subcategory", empty: "No categories yet", emptyHint: "For example: Coffee, Drinks, Hot dishes, Desserts.",
  },
  modifiers: {
    saved: "Group saved", notSelected: "Not selected", newTitle: "New modifier group", newGroup: "New group",
    usedIn: "The group is used in {{count}} items. Open orders keep their previous modifiers.",
    groupName: "Group name", groupNamePlaceholder: "Add-ons / Milk / Doneness",
    selection: "Selection", selectionType: "Selection type", single: "Single choice", multiple: "Multiple",
    min: "Minimum", minHint: "≥ 1 — required group", max: "Maximum", maxHint: "Empty — no limit",
    free: "Free, pcs", freeHint: "First N — no extra charge", allowQuantity: "Allow several of the same (×2 cheese)",
    namePlaceholder: "Cheese", writeOff: "Write off product", product: "Product", quantity: "Quantity (in base unit)",
    replaces: "Replaces ingredient", replacesHint: "For example, plant milk instead of cow's milk", replaced: "Replaced",
    removes: "Removes ingredient", removesHint: "“No onion”", removed: "Removed",
    kitchenLabel: "Kitchen label", kitchenLabelPlaceholder: "+cheese", isDefault: "Selected by default", add: "Add modifier",
    required: "Required", optional: "Optional", one: "One", upTo: "Up to {{max}}", inItems: "In {{count}} items",
    deleteTitle: "Delete group “{{name}}”?", empty: "No modifier groups", emptyHint: "Add-ons, milk choice, doneness, “no onion”.",
  },
  items: {
    title: "Menu item", newTitle: "New item", newSaved: "New item (saved)",
    saved: "Item saved", createdNext: "Item created — now you can build the recipe card",
    onSale: "On sale", onSaleHint: "A disabled item isn't sold anywhere", visiblePublic: "Visible to guests", visiblePublicHint: "QR menu and website",
    allowDiscount: "Discounts allowed", isWeighted: "Sold by weight",
    isWeightedHint: "Pilaf, fish, salads by weight: the price is per 1 kg, the cashier enters the weight in grams or kilograms", pricePerKg: "Price per 1 kg", recipeWeighted: "This item is sold by weight: the recipe yield is in kilograms. E.g. a 12 kg pot of pilaf — yield 12; selling 450 g writes off 0.45 / 12 of the pot ingredients.",
    basePricePlaceholder: "Base: {{price}}", branchPrice: "Price in branch {{name}}",
    branchesHint: "The base price is shared across the company. In a branch you can hide the item or set its own price — an empty field means the base price (BR-052).",
    photo: "Item photo", namePlaceholder: "Latte", oldPrice: "Old price (strikethrough)", sku: "SKU",
    stockProduct: "Stock product", stockProductHint: "Written off directly on sale, without a recipe",
    weight: "Weight, g", volume: "Volume, ml", calories: "Calories, kcal", cookingTime: "Cooking time, min",
    descriptionPlaceholder: "Ingredients and serving — visible to guests in the QR menu and website",
    posTags: "Terminal tags", posTagsHint: "Quick filters on the Kafe Coco terminal; type a name to create a tag", barcodes: "Barcodes", barcodesHint: "For the terminal scanner: enter a code and press Enter", barcodePlaceholder: "4600000000017", removeBarcode: "Remove barcode {{code}}",
    tagsLabel: "Tags", allergensLabel: "Allergens",
    minAge: "Age restriction", minAgeHint: "For alcohol and tobacco the cashier confirms age (BR-049)",
    variants: "Variants", variantsHint: "Sizes and volumes with their own price (S/M/L, 25/30/40 cm). Without variants it's sold at the base price.",
    variantPlaceholder: "For example, 300 ml", variantName: "Variant name", variantPrice: "Variant price", byDefault: "Default",
    deleteVariant: "Delete variant", addVariant: "Add variant",
    modifierGroups: "Modifier groups", modifierGroupsHint: "Add-ons, doneness, milk. The cashier can't skip required groups (BR-025).",
    noneSelected: "None selected", groupSummary: "{{count}} pcs · {{kind}}",
    recipe: "Recipe", recipeFirst: "Create the item first — then build its recipe card.",
    types: { dish: "Dish", drink: "Drink", product: "Goods", service: "Service", combo: "Combo", modifier_only: "Modifier only" },
    tags: { new: "New", hit: "Bestseller", spicy: "Spicy", vegan: "Vegan", vegetarian: "Vegetarian", halal: "Halal" },
    allergens: {
      gluten: "Gluten", lactose: "Lactose", eggs: "Eggs", nuts: "Nuts", peanuts: "Peanuts", soy: "Soy", fish: "Fish", shellfish: "Shellfish",
      sesame: "Sesame", celery: "Celery", mustard: "Mustard", sulfites: "Sulfites",
    },
  },
  units: { g: "g", kg: "kg", ml: "ml", l: "l", pcs: "pcs", portion: "portion" },
  recipe: {
    noConversion: "The unit can't be converted to the product unit", checkRows: "Check the recipe rows", cycle: "Circular reference",
    publishTitle: "Publish the recipe?", publishHint: "New sales will be written off by this version. The previous version will be archived; closed orders won't change.",
    publish: "Publish", published: "Recipe published", discardTitle: "Discard the draft?", discard: "Discard draft",
    draftV: "Draft v{{v}}", publishedV: "Published v{{v}}", none: "No recipe", salesUse: "Sales are written off by published v{{v}}",
    incomplete: "Cost is incomplete", output: "Yield", outputUnit: "Yield unit",
    ingredient: "Ingredient", gross: "Gross", unitShort: "Unit", waste: "Waste %", loss: "Loss %", netSum: "Net / amount",
    productPlaceholder: "Product or semi-finished product", noPrice: "no price", takeawayOnly: "Takeaway only", deleteRow: "Delete row",
    takeawayHint: "Only for takeaway and delivery (packaging)", addIngredient: "Add ingredient",
    cost: "Cost", perPortion: "Per portion", perOutput: "Per yield",
    instructions: "Preparation method", instructionsPlaceholder: "Preparation steps, temperature, serving",
    draftSaved: "Draft saved", saveDraft: "Save draft", history: "Version history",
    statusActive: "active", statusDraft: "draft", statusArchive: "archived",
    owner: "Recipe for", forItem: "Dish (shared)", variantsHint: "Each variant has its own recipe. If a variant has none, sales write off the dish recipe.",
    copy: "Copy to…", copyTitle: "Copy recipe", copyAction: "Copy",
    copyHint: "Ingredients, method and yield go to drafts of the selected variants (their drafts are replaced). Publish each one separately.",
    factorFor: "Factor for “{{name}}”", factorHint: "The factor multiplies gross quantities: 1 — as is, 1.5 — 50% more (S → L).",
    copied: "Recipes copied: {{count}}",
  },
  products: {
    description: "Ingredients, goods, semi-finished products and packaging — the basis of recipes and stock.",
    add: "Add product", newTitle: "New product", saved: "Product saved",
    searchPlaceholder: "Name, SKU or barcode", allTypes: "All types",
    empty: "No products yet", emptyHint: "Add ingredients with a purchase price — dish costs will be calculated automatically.",
    namePlaceholder: "Milk 3.2%", baseUnit: "Tracked in", baseUnitHint: "Can be changed only if the product isn't in a recipe",
    baseUnits: { g: "grams", ml: "milliliters", pcs: "pieces" }, unitColumn: "Unit",
    purchasePrice: "Purchase price", purchasePriceFor: "Purchase price per {{unit}}", perBaseHint: "= {{price}} tyiyn per {{unit}}", priceAutoHint: "Updated automatically on receiving",
    purchaseLoss: "Default purchase loss", purchaseLossHint: "Filled into the purchase line: bones, trimming, thawing", purchaseLossQtyHint: "Fixed: this many {{unit}} are lost on every purchase (packaging, ice)", waste: "Default waste, %", wasteHint: "Pre-filled in recipes", barcodes: "Barcodes", barcodesHint: "Comma-separated",
    density: "Density, g/ml", densityHint: "Needed to use grams for liquids in recipes (and vice versa)",
    shelfLife: "Shelf life, days", minStock: "Minimum stock", minStockHint: "In {{unit}} — for notifications",
    allergensHint: "Menu items inherit ingredient allergens", productionRecipe: "Production recipe",
    types: { ingredient: "Ingredient", goods: "Goods", semi_finished: "Semi-finished", packaging: "Packaging", consumable: "Consumable" },
  },
  costing: {
    descriptionGross: "Food cost target — {{pct}}%. Cost by gross weight and current purchase prices.",
    descriptionNet: "Food cost target — {{pct}}%. Cost by net weight and current purchase prices.",
    settingsTitle: "Costing settings", settingsSaved: "Settings saved",
    target: "Target food cost, %", targetHint: "Items above target are highlighted; the recommended price is based on it",
    rounding: "Round the recommended price to", base: "Calculate ingredient cost by", baseShort: "Calculation basis", net: "Net",
    overTarget: "Above target · {{count}}", noRecipe: "No recipe · {{count}}", costShort: "Cost", noRecipeBadge: "no recipe", noPrices: "no prices",
    margin: "Margin", markup: "Markup", recommended: "Recommended price",
    empty: "No items", emptyHint: "Add menu items and build their recipe cards.",
    incompleteNote: "* — cost is incomplete: some ingredients have no purchase price.",
  },
  upload: {
    photo: "Photo", chooseImage: "Choose an image", tooLarge: "File is too large",
    drop: "Drag a photo here or click to choose", formats: "JPEG, PNG, WebP, HEIC · up to 10 MB", replace: "Replace", remove: "Remove",
  },
  tables: {
    description: "Floor plan of the current branch, table statuses and QR codes.",
    status: { free: "Free", occupied: "Occupied", awaiting_payment: "Awaiting payment", reserved: "Reserved", cleaning: "Cleaning", unavailable: "Unavailable" },
    hallTypes: { hall: "Hall", vip: "VIP", terrace: "Terrace", room: "Room", banquet: "Banquet", bar: "Bar" },
    shapes: { square: "Square", rect: "Rectangle", round: "Round" },
    planOf: "Floor plan “{{name}}”", tableAria: "Table {{number}}, {{count}} seats, {{status}}", seatsShort: "{{count}} seats",
    hall: "Hall", newHall: "New hall", hallPlaceholder: "Main hall", createHall: "Create hall",
    noHalls: "No halls yet", noHallsHint: "Create a hall and place tables — waiters and cashiers will pick a table from the plan.",
    table: "Table {{number}}", tableShort: "Table", newTable: "New table", tableStatus: "Table status",
    number: "Number", seats: "Seats", shape: "Shape", width: "Width", height: "Height", rotation: "Rotation, °",
    gridTitle: "Terminal layout", gridHint: "Table position in the Kafe Coco terminal floor grid. Leave empty to place automatically.", gridRow: "Row", gridColumn: "Column", gridSpan: "Width, columns",
    nameOptional: "Name (optional)", namePlaceholder: "By the window", isActive: "Table in use",
    qr: "Table QR code", copy: "Copy", linkCopied: "Link copied", qrSticker: { open: "QR code", title: "Table {{number}} QR code", preview: "Table sticker", print: "Print", png: "Download PNG", table: "Table", hintOrder: "Menu, ordering and calling a waiter", hintMenu: "Our menu" },
    regenerate: "Reissue", regenerateTitle: "Reissue the QR code?", regenerateHint: "Old stickers will stop working.",
    deleteTable: "Delete table {{number}}?", planSaved: "Floor plan saved",
    view: "View", plan: "Plan", list: "List", savePlan: "Save plan", arrange: "Arrange",
    renameHall: "Rename hall", deleteHall: "Delete hall", deleteHallTitle: "Delete hall “{{name}}”?", deleteHallHint: "The hall's tables will be deleted too.",
    statuses: "Statuses", dragHint: "Drag tables with the mouse or your finger. Grid — {{grid}} units.",
    noTables: "No tables in this hall", addTable: "Add table",
  },
  orders: {
    payments: "Payments",
    refunds: "Refunds",
    refund: "Issue refund",
    refundTitle: "Refund for order {{n}}",
    refundAmount: "Refund amount",
    refundReason: "Refund reason",
    refundPayment: "Payment",
    refundAvailable: "Available to refund: {{amount}}",
    refundDone: "Refund issued",
    paidSum: "Paid",
    refundedSum: "Refunded",
    tax: "Tax",
    taxIncluded: "Incl. tax",
    methods: {
      qr: "QR",
      credit: "On credit",
      cash: "Cash",
      card: "Card",
      deposit: "Banquet deposit",
    },
    anyPayment: "Not linked to a payment",
    title: "Orders",
    description: "Branch orders: open and history.",
    open: "Open",
    all: "All",
    number: "Number",
    dailyNo: "#{{n}}",
    type: "Type",
    table: "Table",
    tableN: "Table {{n}}",
    items: "Items",
    total: "Total",
    opened: "Opened",
    empty: "No orders",
    emptyHint: "New orders are created at the POS",
    history: "History",
    search: "Number or guest name",
    guests: "Guests",
    guest: "Guest",
    comment: "Order comment",
    cancel: "Cancel order",
    cancelTitle: "Cancel order {{n}}?",
    cancelHint: "Sent items will be voided and the kitchen notified.",
    reason: "Reason",
    reasonComment: "Comment",
    void: "Void",
    voidTitle: "Void “{{name}}”?",
    voidSentHint: "The item is already in the kitchen — the cook will be notified.",
    cancelled: "Order cancelled",
    voided: "Item voided",
    details: "Order {{n}}",
    openInPos: "Open in POS",
    events: {
      line_added: "Item added",
      qty_changed: "Quantity changed",
      payment: "Payment",
      refund: "Refund",
      "order.update": "Updated",
      created: "Created",
      items_added: "Items added",
      item_updated: "Item changed",
      item_voided: "Item voided",
      sent_to_kitchen: "Sent to kitchen",
      cancelled: "Cancelled",
      transferred: "Moved to another table",
      updated: "Updated",
    },
    statuses: {
      draft: "Draft",
      open: "Open",
      confirmed: "Confirmed",
      cooking: "Cooking",
      ready: "Ready",
      served: "Served",
      paid: "Paid",
      completed: "Closed",
      cancelled: "Cancelled",
      refunded: "Refunded",
      partially_refunded: "Partially refunded",
    },
    itemStatuses: {
      new: "New",
      sent: "In kitchen",
      accepted: "Accepted",
      cooking: "Cooking",
      ready: "Ready",
      served: "Served",
      voided: "Voided",
      returned: "Returned",
    },
    types: {
      dine_in: "Dine-in",
      takeaway: "Takeaway",
      delivery: "Delivery",
      self_service: "Self-service",
      pickup: "Pickup",
    },
    reasons: {
      guest_mistake: "Guest mistake",
      waiter_mistake: "Staff mistake",
      long_wait: "Long wait",
      out_of_stock: "Out of stock",
      quality: "Quality",
      other: "Other",
    },
  },
  pos: {
    transferWaiter: "Hand over to a waiter",
    transfer: "Hand over",
    noWaiters: "No waiters: add them to zones under “Waiters by hall” or clock in.",
    waiter: "Waiter",
    pickWaiter: "Choose a waiter",
    waiterIs: "Waiter: {{name}}",
    transferred: "Table handed over",
    promotions: "Promotions",
    promotionsHint: "Matching promotions are calculated automatically and recalculated when the order changes.",
    applyPromotions: "Promotions",
    promotionsOn: "Promotions on",
    promotionsSwitch: "Apply promotions",
    promotionsSwitchHint: "Turn off to remove all promotions from the order",
    promoCodes: "Promo codes",
    promoCodesHint: "Comma-separated, e.g. WELCOME10",
    promoCodeInvalid: "Promo code not found or not active",
    promotionsSaved: "Promotions recalculated",
    discount: "Discount",
    discountHint: "Applies to items that allow discounts. Above your limit a manager PIN is required.",
    applyDiscount: "Apply",
    removeDiscount: "Remove discount",
    discountKind: "Discount type",
    discountPercent: "Percent",
    discountAmount: "Amount",
    discountReason: "Reason",
    discountValueRequired: "Enter the discount",
    discountPreview: "Discount",
    discountSaved: "Discount applied",
    addDiscount: "Add discount",
    changeDiscount: "Change discount",
    discountReasons: {
      regular: "Regular guest",
      compliment: "Compliment",
      staff: "Staff",
      promo: "Promotion",
      complaint: "Guest complaint",
      other: "Other",
    },
    pickCustomer: "Customer",
    clearCustomer: "Remove customer",
    noShift: "Cash shift is not open",
    noShiftHint: "Ask a cashier or manager to open the web register shift.",
    creditNoCustomer: "Select a customer to sell on credit",
    creditOverLimit: "Credit is unavailable or the limit is exceeded. Available: {{left}}",
    creditInfo: "{{name}}: debt {{debt}} of {{limit}} limit",
    reference: "RRN or last 4 digits",
    referenceHint: "Optional — for reconciliation with the terminal",
    payTitle: "Pay order {{n}}",
    due: "Amount due",
    method: "Payment method",
    amount: "Payment amount",
    received: "Received from guest",
    tip: "Tip",
    change: "Change",
    payConfirm: "Accept {{amount}}",
    paidDone: "Order paid",
    partPaid: "Paid {{paid}} of {{total}}",
    tax: "Tax",
    taxIncluded: "Incl. tax",
    exact: "Exact amount",
    notEnough: "Received less than the payment amount",
    paidAlready: "Paid",
    printReceipt: "Print receipt",
    title: "POS",
    newOrder: "New order",
    openOrders: "Open orders",
    orderHistory: "Order history",
    reservations: "Reservations",
    noOpen: "No open orders",
    searchMenu: "Search menu…",
    orderDetails: "Order details",
    orderInfo: "Order information",
    customerName: "Guest name",
    selectTable: "Select table",
    tableN: "Table {{n}}",
    addNote: "Order note",
    notePlaceholder: "Write your order note here…",
    addToOrder: "Add to order",
    empty: "Add items from the menu",
    subtotal: "Subtotal",
    total: "Total",
    send: "To kitchen",
    sendN: "To kitchen · {{n}}",
    sent: "Sent to kitchen",
    precheck: "Pre-check",
    pay: "Pay",
    paySoon: "Payments will arrive in the next update",
    stopped: "Stop",
    left: "{{n}} left",
    modifiersTitle: "Choose options",
    required: "required",
    upTo: "up to {{n}}",
    chooseOne: "choose one",
    quantity: "Quantity",
    itemComment: "Item comment",
    weight: "Weight", weightHint: "{{price}} per 1 kg — weigh it and enter the weight", changeWeight: "Change weight", weightLine: "{{weight}} × {{price}}/kg", saveWeight: "Save weight",
    add: "Add · {{price}}",
    variant: "Size",
    course: "Course {{n}}",
    guestsN: "Guests: {{n}}",
    back: "Back",
    switchUser: "Switch user",
    online: "Online",
    reconnecting: "Reconnecting…",
    offline: "Offline",
    orderReady: "Order #{{n}} is ready",
    cart: "Order · {{n}}",
    tableSelect: "Table selection",
    noHalls: "No halls — create them in “Halls & tables”",
    noOrder: "No order selected",
    quick: {
      noOnion: "no onion",
      spicy: "spicier",
      noIce: "no ice",
      hot: "extra hot",
    },
  },
  kds: {
    title: "Kitchen",
    station: "Station",
    chooseStation: "Choose a station",
    noStations: "No stations — open “Kitchen stations”",
    new: "New",
    cooking: "Cooking",
    ready: "Ready",
    start: "Start",
    done: "Done",
    serve: "Serve",
    recall: "Recall",
    accept: "Accept",
    empty: "No orders",
    emptyHint: "New orders will appear here automatically",
    minutes: "{{n}} min",
    soundOn: "Sound on",
    soundOff: "Enable sound",
    keyboardHint: "1–9 select a ticket, Enter — next step",
    recalled: "Returned to work",
    print: "Print",
    repeatReadySound: "Replay ready sound",
    exit: "Exit",
    newTicket: "New order #{{n}}",
    managerLogin: "Manager sign-in",
  },
  readyBoard: {
    title: "Order status",
    preparing: "Preparing",
    ready: "Ready — please collect",
    empty: "No orders yet",
    fullscreen: "Full screen",
    background: "Board background",
    backgrounds: { white: "White", warm: "Warm white", gray: "Light gray", graphite: "Graphite" },
    palette: "Color palette",
    palettes: { coca: "Coca", ocean: "Ocean", forest: "Emerald", violet: "Violet" },
    voice: "Voice",
    enableVoice: "Enable sound",
    speech: "Order number {{number}} is ready",
    speechNamed: "{{name}}, your order number {{number}} is ready",
  },
  stations: {
    "warehouse": "Station warehouse",
    "warehouseHint": "Sales of this station's items are deducted from the selected warehouse",
    "mainWarehouse": "Branch main warehouse",
    title: "Kitchen stations",
    description: "Kitchen sections and screens: where order items go.",
    add: "Add station",
    type: "Type",
    norm: "Cooking time target, min",
    normHint: "A ticket turns yellow after the target and red after 1.5×",
    simple: "Simple mode",
    simpleHint: "Coffee shop: one tap marks a ticket ready",
    isDefault: "Default",
    defaultHint: "Items without a station go here",
    active: "Active",
    activeTickets: "Active tickets: {{n}}",
    empty: "No stations",
    emptyHint: "A “Kitchen” station is created on the first kitchen send",
    deleteTitle: "Delete station “{{name}}”?",
    itemStation: "Kitchen station",
    itemStationHint: "Empty — the branch default station",
    types: {
      hot: "Hot section",
      cold: "Cold section",
      bar: "Bar",
      coffee: "Coffee",
      bakery: "Bakery",
      pizza: "Pizza",
      grill: "Grill",
      dessert: "Desserts",
      packing: "Packing",
      expo: "Expo",
    },
  },
  print: {
    document: "Document",
    print: "Print",
    savePdf: "Save PDF",
    excel: "Download Excel",
    pdfHint: "In the print dialog, choose “Save as PDF”",
    printedAt: "Printed",
    precheck: "Pre-check",
    notFiscal: "Not a fiscal document",
    table: "Table",
    guests: "Guests",
    total: "Total",
    thanks: "Thank you!",
    printed: "Sent to printer",
    usb: {
      title: "Receipt printer (USB)",
      description: "Receipts, pre-checks, kitchen tickets and shift reports print straight to the printer — no print dialog. The setting is stored on this device.",
      menu: "Receipt printer",
      pick: "Choose USB printer",
      change: "Another",
      connected: "Printer connected",
      savedHere: "Connected to this device",
      howTo: "Connect a receipt printer (ESC/POS) to this computer with a USB cable and press the button below — the browser will show a list of devices.",
      enabled: "Print to USB printer",
      enabledHint: "Off — print via the browser dialog",
      paper: "Paper width",
      mm: "{{n}} mm",
      cut: "Cut paper after receipt",
      test: "Test print",
      testTitle: "Test print",
      drawer: "Open cash drawer",
      forget: "Disconnect",
      busyHint: "If the printer does not respond, on Windows it is held by its own driver: replace the driver with WinUSB (Zadig). On Linux, unload the usblp module.",
      unsupportedTitle: "This browser does not support USB printing",
      unsupported: "Use Google Chrome or Microsoft Edge on a computer and an https address. In Safari, Firefox and on iPhone printing goes through the browser dialog.",
      errors: {
        notFound: "USB printer not found: check the cable and power. Printing via the browser dialog.",
        busy: "The printer is held by the system driver. On Windows replace the driver with WinUSB (Zadig), on Linux unload usblp.",
        noEndpoint: "This device does not look like a receipt printer.",
        notConfigured: "No USB printer selected.",
        cancelled: "No printer selected.",
        denied: "The browser blocked USB access on this page.",
        failed: "Could not print to the USB printer: {{message}}",
      },
    },
  },
  reports: {
    title: "Sales report",
    description: "Revenue from payments and refunds, orders, average check and top dishes for the period.",
    from: "From",
    to: "To",
    groupBy: "Group by",
    byHour: "By hour",
    byDay: "By day",
    revenue: "Revenue",
    revenueHint: "Payments − refunds",
    orders: "Orders",
    avgCheck: "Average check",
    refunds: "Refunds",
    tips: "Tips",
    tax: "Tax",
    cancelled: "Cancelled",
    payments: "Payments",
    cash: "Cash",
    card: "Card",
    chart: "Revenue over time",
    top: "Top dishes",
    product: "Dish",
    qty: "Qty",
    sum: "Amount",
    noData: "No sales in this period",
    mismatches: "Sold at a price different from the menu",
    mismatchHint: "The terminal accepted the order at its own price (e.g. offline before the menu update). The server does not recalculate such orders.",
    menuPrice: "Menu price",
    soldPrice: "Sold at",
    lines: "Lines",
    presets: {
      today: "Today",
      yesterday: "Yesterday",
      week: "7 days",
      month: "30 days",
    },
  },
  reservations: {
    title: "Reservations",
    description: "Table reservations: terminals see them immediately and mark the table an hour before guests arrive.",
    add: "New reservation",
    edit: "Reservation",
    customer: "Guest name",
    phone: "Phone",
    guests: "Guests",
    date: "Date",
    time: "Time",
    duration: "Duration",
    startsAt: "Start",
    endsAt: "End",
    tables: "Tables",
    note: "Comment",
    status: "Status",
    statuses: {
      booked: "Booked",
      seated: "Seated",
      completed: "Completed",
      cancelled: "Cancelled",
      no_show: "No-show",
    },
    empty: "No reservations",
    emptyHint: "Create a reservation — terminals will see it and mark the table",
    cancel: "Cancel reservation",
    cancelTitle: "Cancel the reservation for “{{name}}”?",
    cancelled: "Reservation cancelled",
    saved: "Reservation saved",
    seat: "Guests arrived",
    noShow: "No-show",
    complete: "Complete",
    conflict: "The reservation was changed on another device — data refreshed",
    minutes: "{{n}} min",
    hours: "{{n}} h",
    noTables: "No table",
    prevDay: "Previous day",
    nextDay: "Next day",
    today: "Today",
    guestsN: "{{n}} guests",
  },
  orderTypes: {
    dine_in: "Dine-in",
    takeaway: "Takeaway",
    delivery: "Delivery",
    self_service: "Self-service",
    pickup: "Pickup",
  },
  expenseCategories: {
    rent: "Rent",
    salary: "Salaries",
    utilities: "Utilities",
    repair: "Repairs",
    marketing: "Marketing",
    transport: "Transport",
    household: "Supplies",
    taxes: "Taxes",
    other: "Other",
  },
  writeoffReasons: {
    spoilage: "Spoilage",
    expired: "Expired",
    cooking_error: "Cooking error",
    breakage: "Breakage",
    staff_meal: "Staff meal",
    tasting: "Tasting",
    internal_use: "Internal use",
    unknown: "Other",
  },
  insights: {
    depositNote: "Banquet deposits: received {{dep}}, applied to orders {{applied}}.",
    laborCost: "Payroll", laborHint: "Accrued in payroll runs", laborPct: "Labor cost {{pct}}%", laborReplaced: "Replaces manual “Salaries” expenses ({{sum}})", salaryPaid: "Salaries paid", tipPoolNote: "Tips for {{n}} days were pooled — amounts come from the distribution, not from orders.", profitHint: "Revenue − cost − write-offs − expenses − payroll",
    methods: { cash: "Cash", card: "Card", qr: "QR", credit: "On credit", deposit: "Banquet deposit" }, debtNote: "Came in = revenue − sold on credit ({{credit}}) + debt repayments ({{repaid}}).",
    title: "Cafe analytics",
    description: "Revenue, expenses, profit, dish sales, ingredient usage, write-offs and waiters for a period.",
    period: "Period",
    presets: {
      today: "Today",
      yesterday: "Yesterday",
      week: "7 days",
      month: "This month",
    },
    tabs: {
      abc: "ABC analysis",
      matrix: "Menu matrix",
      costs: "Food & labor cost",
      heatmap: "By hour",
      branches: "Branches",
      finance: "Finance",
      items: "Dishes",
      categories: "Categories",
      products: "Ingredients",
      writeoffs: "Write-offs",
      waiters: "Waiters",
    },
    byDays: "By day",
    date: "Date",
    noData: "No data for the period",
    noSales: "No sales for the period",
    revenue: "Revenue",
    revenueHint: "Refunds: {{refunds}} · tips: {{tips}}",
    costOfSales: "Cost of sales",
    foodCost: "Food cost {{pct}}%",
    costHint: "Ingredients by recipe",
    expenses: "Expenses",
    expensesHint: "Rent, salaries and more",
    profit: "Profit",
    margin: "Margin {{pct}}%",
    grossProfit: "Gross profit",
    grossProfitHint: "Revenue − cost of sales",
    purchases: "Purchases",
    writeoffs: "Write-offs",
    cashLeft: "Money left",
    cashLeftHint: "Came in − purchases − expenses",
    noRecipeTitle: "Some dishes have no recipe",
    noRecipeHint: "Cost and ingredient usage are not calculated for: {{items}}. Fill in recipes in the menu.",
    whereFrom: "Where revenue comes from",
    whereFromHint: "By menu category (sum of items)",
    noCategory: "No category",
    whereTo: "Where the money went",
    whereToHint: "Expenses, purchases and write-offs",
    noExpenses: "No expenses for the period",
    byOrderType: "By order type",
    ordersN: "orders: {{n}}",
    byMethod: "By payment method",
    moneyFlow: "Money flow",
    moneyFlowHint: "How much came in, went out and is left",
    cameIn: "Came in",
    purchasesPaid: "Paid for purchases",
    supplierCreditNote: "Purchases on credit from suppliers: {{amount}} — leave the cash when paid",
    profitByDay: "Profit by day",
    categoriesQty: "Sold by category",
    categoriesHint: "Units sold in each category; click a row for daily figures",
    pcs: "pcs",
    category: "Category",
    sold: "Sold",
    perDay: "Average per day",
    itemsTitle: "Sales by dish",
    itemsHint: "Click a dish to see daily sales",
    searchItem: "Find a dish or category",
    purchased: "Purchased",
    usedCost: "Used, cost",
    usedHint: "By recipes of dishes sold",
    writtenOff: "Written off",
    topUsed: "Most used",
    topUsedHint: "By cost of usage",
    noUsage: "No ingredient movement for the period",
    productsTitle: "Ingredients",
    searchProduct: "Find an ingredient",
    product: "Ingredient",
    used: "Used",
    noWriteoffs: "No write-offs for the period",
    documents: "Documents",
    byReason: "By reason",
    docsN: "{{n}} docs",
    byProduct: "By ingredient",
    reasons: "Reasons",
    noWaiter: "No waiter",
    waitersRevenue: "Revenue by waiter",
    waiter: "Waiter",
    guests: "Guests",
    itemsSold: "Items",
    serviceTime: "Service time",
    minutes: "{{n}} min",
    cancels: "Cancels / voids",
    pro: {
      locked: "Available with the “Reports (advanced)” add-on",
      lockedHint: "ABC analysis, menu matrix, food and labor cost, sales by hour and branch comparison — what earns money and what to drop or reprice.",
      export: "Export CSV",
      abcBy: "Measure",
      abcByOptions: {
        revenue: "Dishes by revenue",
        margin: "Dishes by margin",
        qty: "Dishes by quantity",
        products: "Products by usage",
        customers: "Customers by spend",
      },
      abcClass: "Class {{c}}",
      abcClassHint: "{{count}} items · {{value}}",
      pareto: "Pareto: top 20%",
      paretoHint: "Share of the top {{count}} items",
      abcHint: "A — the first 80%, B — the next 15%, C — the rest. Class C items are candidates for replacement.",
      name: "Name",
      value: "Value",
      share: "Share",
      cumulative: "Cumulative",
      class: "Class",
      noRecipe: "no recipe",
      matrixHint: "Popular — sales share from {{pop}}; profitable — margin per portion from {{margin}}. Cost — by recipes.",
      matrixNoRecipes: "Fill in recipes — without them margin can't be calculated.",
      quad: {
        star: "Stars",
        plowhorse: "Plowhorses",
        puzzle: "Puzzles",
        dog: "Dogs",
      },
      quadHint: {
        star: "Popular and profitable — keep the quality and menu spot.",
        plowhorse: "Sell well but earn little — raise the price or cut the cost.",
        puzzle: "Profitable but rarely ordered — promote: photo, menu spot, waiter tip.",
        dog: "Few sales and little profit — candidates for replacement.",
      },
      matrixRow: "{{qty}} pcs · margin {{margin}} · fc {{fc}}",
      withoutRecipe: "No recipe — not in the matrix",
      foodCost: "Food cost",
      laborCost: "Labor cost",
      primeCost: "Prime cost",
      primeCostHint: "Cost of goods + payroll",
      perLaborHour: "Revenue per labor hour",
      laborHours: "{{hours}} h by work shifts",
      foodCostByDays: "Food cost by day",
      byCategory: "By category",
      revenue: "Revenue",
      hours: "Hours",
      branchesTitle: "Branch comparison",
      branchesTotal: "Total: {{revenue}}, orders {{orders}}, profit {{profit}}",
      orders: "Orders",
      avgCheck: "Average check",
      profit: "Profit",
      heatmapTitle: "Revenue by weekday and hour",
      heatmapHint: "Darker means more revenue. Time is the venue's local time.",
      ordersN: "orders: {{count}}",
      less: "less",
      more: "more",
      heatmapDays: "{{from}} — {{to}}",
      weekdays: {
        "1": "Mon",
        "2": "Tue",
        "3": "Wed",
        "4": "Thu",
        "5": "Fri",
        "6": "Sat",
        "7": "Sun",
      },
    },
  },
  expenses: {
    title: "Expenses",
    description: "Rent, salaries, utilities and other expenses. Ingredient purchases go to “Purchases”.",
    add: "Add expense",
    editTitle: "Edit expense",
    saved: "Expense saved",
    category: "Category",
    date: "Date",
    amount: "Amount",
    comment: "Comment",
    commentPlaceholder: "E.g. October rent",
    deleteTitle: "Delete “{{name}}” expense of {{sum}}?",
    allCategories: "All categories",
    total: "Total",
    empty: "No expenses yet",
    emptyHint: "Add expenses — they go into the financial report and profit.",
  },
  inventory: {
    stockTitle: "Stock on hand",
    stockDescription: "How much of each product the branch has and what it is worth. Sales deduct products by recipe cards automatically.",
    search: "Product, SKU or barcode",
    onlyLow: "Only low and negative",
    showAll: "Include products without movements",
    quantity: "On hand",
    minStock: "Minimum",
    value: "Value",
    totalValue: "Stock value",
    state: "State",
    states: {
      ok: "OK",
      low: "Low",
      negative: "Negative",
    },
    empty: "No stock yet",
    emptyHint: "Post a purchase or a stock count and balances will appear here.",
    card: "Movement card",
    opening: "Opening",
    closing: "Closing",
    incoming: "In",
    outgoing: "Out",
    balance: "Balance after",
    operation: "Operation",
    when: "When",
    order: "order #{{n}}",
    noMovements: "No movements in this period",
    moveTypes: {
      "disassembly": "Breakdown",
      "assembly": "Assembly",
      "return_to_supplier": "Return to supplier",
      "transfer_out": "Transfer (out)",
      "transfer_in": "Transfer (in)",
      "production": "Production",
      receipt: "Purchase",
      writeoff: "Write-off",
      consumption: "Sale",
      inventory_adjustment: "Stock count",
      reversal: "Reversal",
      cost_adjustment: "Cost adjustment",
    },
    countsTitle: "Stock counts",
    countsDescription: "Recount products. Sales during the count are taken into account; differences are posted as an adjustment.",
    newCount: "Start a stock count",
    newCountHint: "System stock is captured at the start; sales can go on.",
    start: "Start",
    scope: "What to count",
    scopes: {
      "location": "Storage location",
      all: "All products",
      category: "Category",
      products: "Selected products",
    },
    pickProducts: "Select products",
    blind: "Blind",
    blindHint: "The counter does not see system stock",
    blindNote: "Blind count: system stock and differences are hidden.",
    started: "Stock count #{{n}} started",
    countTitle: "Stock count #{{n}}",
    number: "Number",
    status: "Status",
    statuses: {
      counting: "Counting",
      posted: "Posted",
      cancelled: "Cancelled",
    },
    counted: "Counted",
    countedOf: "Counted {{n}} of {{total}}",
    system: "System",
    fact: "Counted",
    diff: "Difference",
    shortage: "Shortage",
    surplus: "Surplus",
    result: "Result",
    onlyDiff: "Only differences",
    notCounted: "not counted",
    noDiff: "No differences",
    saveCounts: "Save counts",
    savedCounts: "Counts saved",
    post: "Post",
    postTitle: "Post stock count #{{n}}?",
    postHint: "Uncounted lines stay unchanged. Shortage is written off by batches, surplus is received at the last purchase price.",
    posted: "Stock count posted",
    cancel: "Cancel",
    cancelTitle: "Cancel stock count #{{n}}?",
    cancelHint: "Stock will not change.",
    cancelled: "Stock count cancelled",
    emptyCounts: "No stock counts yet",
    emptyCountsHint: "Start the first one — it also sets the opening stock.",
  },
  stockDocs: {
    backToList: "Back to purchases",
    receiptPageDescription: "What you bought, how much and at what price. Receiving loss (bones, trimming, thawing) reduces what goes to stock — the unit price is based on the net weight.",
    newProduct: "New product",
    createProduct: "Add product “{{name}}”",
    loss: "Loss",
    lossMode: "Loss as percent or quantity",
    lossQty: "Loss",
    toStock: "To stock",
    wasPrice: "was {{price}}",
    "expiresAt": "Best before",
    "expiresHint": "empty — by the product's shelf life",
    receiptsTitle: "Purchases",
    writeoffsTitle: "Write-offs",
    receiptsDescription: "What you bought and at what price. A purchase updates the ingredient price used for dish cost.",
    writeoffsDescription: "Spoiled, expired and otherwise written-off ingredients, with a reason.",
    newReceipt: "New purchase",
    newWriteoff: "New write-off",
    post: "Post",
    saved: "Document posted",
    supplier: "Supplier",
    supplierPlaceholder: "Choose or add a supplier",
    dueTitle: "Change due date",
    returnEmpty: "Enter how much to return",
    returnFromReceipt: "Return to supplier from purchase",
    returnReason: "Reason: defect, wrong item…",
    returnable: "Can return {{qty}} of {{bought}}",
    returnSum: "Return amount (at purchase prices)",
    returnHint: "Goods leave stock from this purchase's batch and the supplier debt drops by the return amount; if the purchase is already paid, the amount becomes an advance.",
    returnToSupplier: "Return to supplier",
    byReceipt: "from purchase",
    toPay: "To pay",
    price: "Price",
    returned: "Returned",
    settlements: "Payments and offsets",
    returnsTitle: "Returns from this purchase",
    returnsPageTitle: "Supplier returns",
    returnsPageDescription: "Goods returned to suppliers: taken from stock at purchase prices; the amount reduces the debt or becomes an advance",
    searchReturn: "Supplier, product or comment",
    emptyReturns: "No supplier returns",
    allSuppliers: "All suppliers",
    newReturn: "Return to supplier",
    return: "Return to supplier",
    createSupplier: "Add supplier “{{name}}”",
    payment: "Payment",
    onCredit: "On credit",
    mixedUnpaid: "The purchase is posted but not fully paid — pay the rest from the supplier card.",
    dueDate: "Pay by",
    dueHint: "Supplier payment terms: {{n}} days",
    paymentAll: "All purchases",
    paymentUnpaid: "Unpaid",
    reason: "Reason",
    addLine: "Add ingredient",
    byLastPrice: "at last purchase price",
    byFifo: "valued by FIFO batches when posted",
    receipt: "Purchase",
    writeoff: "Write-off",
    products: "Ingredients",
    open: "Open",
    deleteTitle: "Delete the document of {{date}} for {{sum}}?",
    deleteHint: "Stock returns to its state before posting and the document leaves reports. The product price is not rolled back.",
    searchReceipt: "Supplier, ingredient, comment",
    searchWriteoff: "Ingredient, comment",
    emptyReceipts: "No purchases for the period",
    emptyWriteoffs: "No write-offs for the period",
    emptyHint: "Documents feed ingredient and finance analytics.",
  },
  cash: {
    title: "Cash shifts",
    description: "Web register shift: opening float, cash in/out, X report and closing with Z report. Archive of all registers of the branch.",
    webRegister: "Web register",
    register: "Register",
    shift: "Shift",
    open: "Open shift",
    openHint: "Enter the opening float — cash in the drawer at the start.",
    opened: "Shift opened",
    close: "Close shift",
    closeHint: "Count the cash in the drawer. The Z report cannot be changed after closing.",
    closeAndPrint: "Close and print Z",
    closed: "Shift closed",
    noShift: "Shift is not open",
    noShiftHint: "Open a shift to accept payments at the web register.",
    statusOpen: "Open",
    statusClosed: "Closed",
    status: "Status",
    openedAt: "Opened",
    closedAt: "Closed",
    cashier: "Cashier",
    float: "Opening float",
    expected: "Expected cash",
    counted: "Counted",
    difference: "Difference",
    diffComment: "Comment on the difference",
    diffCommentRequired: "Describe the reason for the difference",
    sales: "Sales",
    refunds: "Refunds",
    net: "Revenue",
    checks: "Checks",
    avgCheck: "Average check",
    tips: "Tips",
    cancelled: "Cancelled orders",
    debtRepaymentsCash: "Debt repayments in cash",
    operation: "Cash in / out",
    operationType: "Operation",
    operationDone: "Operation recorded",
    operations: "Operations",
    amount: "Amount",
    reason: "Reason",
    xReport: "X report",
    zReport: "Z report",
    printX: "Print X report",
    printZ: "Print Z report",
    archive: "Shift archive",
    archiveEmpty: "No shifts yet",
    ops: {
      banquet_deposit: "Banquet deposit",
      banquet_refund: "Banquet deposit refund",
      salary_payout: "Salary payout",
      supplier_payment: "Supplier payment",
      supplier_refund: "Refund from supplier",
      cash_in: "Cash in",
      cash_out: "Cash out",
      collection: "Collection",
      expense: "Expense from drawer",
      tip_payout: "Tip payout",
      debt_repayment: "Debt repayment",
      correction_in: "Correction +",
      correction_out: "Correction −",
    },
  },
  suppliers: {
    avgShort: "avg {{price}}",
    payAdvance: "Pay advance",
    refund: "Refund money",
    refunded: "Refund recorded",
    refundTitle: "Supplier refunds money: {{name}}",
    refundShort: "Refund from supplier",
    refundCashHint: "Cash goes into the open cash shift",
    voidRefundTitle: "Void refund of {{amount}}?",
    voidRefundHint: "The supplier advance is restored. Cash is taken from the register if the shift is still open.",
    products: "Products",
    noProducts: "No purchases from this supplier yet",
    bought: "Purchased",
    returnedQty: "returned {{qty}}",
    lastPrice: "Last price",
    avgPrice: "Average price",
    refundMethods: {
      cash: "Cash to register",
      bank: "To bank account",
    },
    advance: "Advance",
    advanceHint: "You can pay more than the debt — the rest is applied to future purchases",
    advanceAlert: "Advance with supplier: {{amount}} — applied to the next purchase",
    advanceLeft: "Advance: {{amount}}",
    advancesNote: "Advances to suppliers: {{amount}} — applied to future purchases",
    statement: {
      open: "Reconciliation",
      title: "Statement of account reconciliation",
      print: "Print",
      period: "for {{from}} – {{to}}",
      date: "Date",
      operation: "Operation",
      increase: "Purchases, refunds",
      decrease: "Payments, goods returns",
      balance: "Balance",
      opening: "Opening balance",
      closing: "Closing balance",
      turnover: "Turnover for the period",
      empty: "No operations in the period",
      weOwe: "Owed to the supplier: {{amount}}",
      theyOwe: "Owed to the buyer (overpayment): {{amount}}",
      settled: "No outstanding balance",
      kinds: {
        receipt: "Purchase",
        return: "Return to supplier",
        payment: "Payment",
        refund: "Refund from supplier",
      },
    },
    title: "Suppliers",
    description: "Supplier directory, purchases on credit and payments to suppliers",
    add: "Add supplier",
    all: "All suppliers",
    payablesTab: "What we owe",
    search: "Name, tax ID, phone",
    empty: "No suppliers yet",
    emptyHint: "Add a supplier or pick one right in a purchase — the debt is tracked automatically",
    name: "Name",
    contactPerson: "Contact person",
    phone: "Phone",
    email: "Email",
    terms: "Payment terms",
    termsHint: "Days from purchase date to due date; 0 — pay immediately",
    taxId: "Tax ID",
    legalName: "Legal name",
    address: "Address",
    notes: "Notes",
    active: "Active",
    activeHint: "An inactive supplier can’t be picked in new purchases",
    inactive: "Inactive",
    info: "Details",
    lastPurchase: "Last purchase",
    nextDue: "Next due",
    weOweShort: "We owe",
    weOwe: "We owe: {{amount}}",
    overdue: "Overdue",
    dueSoon: "Due in 7 days",
    purchased: "Purchased total",
    paidTotal: "Paid total",
    noTerms: "Immediately",
    overdueAlert: "Overdue payment to supplier: {{amount}}",
    documents: "Purchases",
    noDocuments: "No purchases yet",
    noDocumentsHint: "Post a purchase and choose this supplier",
    payments: "Payments",
    noPayments: "No payments yet",
    voided: "Voided",
    pay: "Pay",
    paid: "Payment recorded",
    payTitle: "Pay supplier: {{name}}",
    payDoc: "Purchase of {{date}}, {{amount}} due",
    method: "Payment method",
    methods: {
      cash: "Cash from register",
      bank: "Bank transfer",
      return: "Goods return",
    },
    reference: "Payment order no.",
    cashHint: "Cash is taken from the open cash shift and reduces the register balance",
    fifoHint: "The amount settles the oldest unpaid purchases first",
    void: "Void payment",
    voidTitle: "Void payment of {{amount}}?",
    voidHint: "The debt to the supplier is restored. Cash returns to the register if the shift is still open.",
    deleteTitle: "Delete supplier “{{name}}”?",
    deleteHint: "Purchases stay in history. A supplier with a debt can’t be deleted.",
    statuses: {
      paid: "Paid",
      partially_paid: "Partially paid",
      unpaid: "Unpaid",
      overdue: "Overdue",
    },
    segments: {
      all: "All",
      debt: "With debt",
      overdue: "Payment overdue",
      inactive: "Inactive",
    },
    aging: {
      d1_30: "1–30 days overdue",
      d31_60: "31–60 days overdue",
      d60: "> 60 days overdue",
    },
    creditors: "Who we owe",
    noCreditors: "No debts to suppliers",
    unpaidDocs: "Unpaid purchases",
  },
  customers: {
    title: "Customers",
    description: "Guest base: order history, favourite dishes, discounts and debts. Shared by all branches.",
    add: "New customer",
    search: "Phone (last digits) or name",
    empty: "No customers yet",
    emptyHint: "Add guests at the register or here",
    name: "Customer",
    firstName: "First name",
    lastName: "Last name",
    phone: "Phone",
    email: "Email",
    birthDate: "Date of birth",
    discount: "Personal discount",
    notes: "Notes",
    consent: "Marketing consent",
    consentHint: "Marketing messages only with consent (the date is recorded)",
    creditAllowed: "Allow selling on credit",
    creditHint: "The register can charge this customer's orders on credit within the limit",
    creditLimit: "Credit limit",
    creditBadge: "Credit up to {{limit}}",
    blocked: "Blocked",
    blockedHint: "No new credit or online orders",
    orders: "Orders",
    ordersN: "orders: {{n}}",
    spent: "Total spent",
    avgCheck: "Average check",
    lastVisit: "Last visit",
    visitEvery: "Visits every",
    days: "{{n}} d",
    debt: "Debt",
    debtShort: "debt {{amount}}",
    overdueAlert: "Overdue: {{amount}} — new credit is unavailable",
    favorites: "Favourite dishes",
    history: "Orders",
    noOrders: "No orders",
    anonymize: "Erase personal data",
    anonymizeTitle: "Erase the customer's personal data?",
    anonymizeHint: "Name, phone, email and notes will be erased. Orders and debt remain. This cannot be undone.",
    anonymized: "Data erased",
    pick: "Order customer",
    quickAdd: "New customer",
    createAndPick: "Create and select",
    segments: {
      all: "All customers",
      debtors: "Debtors",
      overdue: "Overdue",
      inactive: "Not visiting for a while",
      vip: "By total spent",
      blocked: "Blocked",
      birthday: "Birthday this week",
    },
  },
  debts: {
    owedToUs: "Owed to us",
    weOwe: "We owe suppliers",
    title: "Debts",
    description: "Debtors, overdue amounts and debt ageing. Repayment is in the customer card.",
    total: "Total debt",
    overdue: "Overdue",
    debtors: "Debtors",
    noDebtors: "No debtors",
    oldest: "Oldest debt",
    aging: {
      d0_7: "Up to 7 days",
      d8_30: "8–30 days",
      d31_60: "31–60 days",
      d60: "Over 60 days",
    },
    ledger: "Debt ledger",
    noEntries: "No debts yet",
    repay: "Repay",
    repayTitle: "Debt repayment: {{name}}",
    repaid: "Debt repaid",
    balance: "Current debt: {{amount}}",
    amount: "Amount",
    comment: "Comment",
    reason: "Reason",
    cashHint: "Cash goes into the open web register shift.",
    adjustTitle: "Debt adjustment",
    increase: "Charge",
    decrease: "Reduce",
    dueDate: "Due date",
    due: "due {{date}}",
    remaining: "{{amount}} left",
    writeOff: "Write off",
    writeOffTitle: "Write off {{amount}}?",
    writeOffHint: "The bad debt will be written off in full. The action is audited.",
    writeOffComment: "Bad debt",
    writtenOff: "Debt written off",
    kinds: {
      charge: "Charge",
      repayment: "Repayment",
      adjustment: "Adjustment",
      write_off: "Write-off",
    },
    statuses: {
      open: "Open",
      partially_paid: "Partially paid",
      paid: "Paid",
      overdue: "Overdue",
      written_off: "Written off",
    },
  },
  staff: {
    employeesTitle: "HR",
    employeesDescription: "Branch staff: position, hire date, pay scheme, who is on shift now. Dismissal blocks sign-in; data is kept.",
    employee: "Employee",
    position: "Position",
    noPosition: "No position",
    hiredAt: "Hire date",
    payScheme: "Pay",
    own: "own",
    ownScheme: "Own pay scheme",
    ownSchemeHint: "Otherwise — the position scheme",
    employmentHint: "Position, hire date and pay scheme. Rate changes are audited.",
    status: "Status",
    offShift: "Off shift",
    onShiftSince: "On shift since {{time}}",
    dismissedAt: "Dismissed {{date}}",
    noEmployees: "No employees",
    dismiss: "Dismiss",
    dismissTitle: "Dismiss {{name}}?",
    dismissHint: "Sign-in and PIN will be blocked, an open shift will be closed. Data and payroll are kept.",
    dismissDate: "Dismissal date",
    dismissReason: "Reason",
    dismissed: "Employee dismissed",
    restore: "Restore",
    restoreTitle: "Restore {{name}}?",
    positionsTitle: "Positions",
    positionsDescription: "Positions and the default pay scheme for their employees.",
    addPosition: "New position",
    deletePosition: "Delete position “{{name}}”?",
    noPositions: "No positions yet",
    defaultScheme: "Default pay scheme",
    scheme: {
      hourlyRate: "Hourly rate",
      shiftRate: "Rate per shift",
      monthlySalary: "Monthly salary",
      salesPercent: "% of personal sales",
      tierFrom: "Higher % from amount",
      tierHint: "Tier: the part of sales above the amount",
      tierPercent: "Higher %",
      nightCoef: "Night coefficient",
      nightHint: "1.5 — night hours +50% (22:00–06:00)",
      tipsViaPayroll: "Pay tips with salary",
      perHour: "{{v}}/hour",
      perShift: "{{v}}/shift",
      perMonth: "{{v}}/month",
      ofSales: "{{v}}% of sales",
    },
  },
  shifts: {
    title: "Work shifts",
    description: "Staff clock-in and clock-out: PIN at the terminal, from the account or manually. Corrections with a reason, timesheet approval.",
    add: "Manual shift",
    onShift: "On shift now: {{n}}",
    nobody: "Nobody is on shift",
    list: "Shifts",
    timesheet: "Timesheet",
    date: "Date",
    time: "Time",
    worked: "Worked",
    night: "Night",
    total: "Total",
    shiftsCount: "Shifts",
    unapproved: "not approved: {{n}}",
    empty: "No shifts in this period",
    select: "Select shift",
    approveAll: "Approve all ({{n}})",
    approveSelected: "Approve selected ({{n}})",
    approvedN: "Shifts approved: {{n}}",
    clockIn: "Start",
    clockOut: "End",
    breakMinutes: "Break, min",
    reason: "Reason",
    correctTitle: "Correction: {{name}}",
    correctHint: "The original time is kept; the change is audited.",
    original: "Was: {{in}} — {{out}}",
    statuses: {
      open: "On shift",
      closed: "Closed",
      auto_closed: "Closed automatically",
      corrected: "Corrected",
      approved: "Approved",
    },
  },
  payroll: {
    title: "Payroll",
    description: "Calculation for a period by pay schemes, review, approval and payout. An approved payroll does not change — corrections go to the next period.",
    calculate: "Calculate",
    runs: "Calculations",
    noRuns: "No calculations yet",
    period: "Period",
    version: "Version",
    employees: "Employees",
    gross: "Accrued",
    net: "To pay",
    calculatedAt: "Calculated",
    sheetTitle: "Payroll {{from}} — {{to}} (v{{v}})",
    approve: "Approve",
    approved: "Payroll approved",
    immutableHint: "The payroll is approved and does not change. Corrections — as a bonus or deduction next period.",
    payCash: "Pay {{amount}} from the register",
    payBank: "Pay by bank",
    payOne: "Pay {{amount}}",
    paid: "Payout recorded",
    noLines: "No accruals — check pay schemes and shifts",
    employeeTotals: "Accrued {{gross}} · to pay {{net}} · paid {{paid}}",
    adjustments: "Bonuses and deductions",
    noAdjustments: "No bonuses or deductions",
    addAdjustment: "Bonus or deduction",
    adjustmentHint: "Goes into the period calculation by date. A reason is required.",
    type: "Type",
    amount: "Amount",
    date: "Date",
    reason: "Reason",
    statuses: {
      calculated: "Calculated",
      approved: "Approved",
      paid: "Paid",
      superseded: "Replaced by recalculation",
    },
    components: {
      hourly: "Hourly",
      night: "Night hours",
      fixed_shift: "Per shift",
      fixed_monthly: "Salary",
      personal_sales_percent: "% of sales",
      tips: "Tips",
      bonus: "Bonus",
      penalty: "Penalty",
      advance: "Advance",
      deduction: "Deduction",
      carry_over: "Carried-over deductions",
      carry_in: "Deduction from previous period",
    },
    basis: {
      hourly: "{{h}} h × {{rate}}",
      night: "{{h}} night h, coef. {{coef}}",
      shifts: "{{n}} shifts × {{rate}}",
      monthly: "{{days}} days of {{salary}} salary",
      sales: "{{pct}}% of {{sales}} sales",
    },
  },
  tips: {
    title: "Tips",
    description: "Guest tips are not venue revenue. Distribution: to the order waiter, a pool split equally or by hours worked; payout from the register or with salary.",
    mode: "Distribution",
    modes: {
      individual: "To order waiter",
      pool_equal: "Pool equally",
      pool_hours: "Pool by hours",
    },
    modeHints: {
      individual: "Everyone gets tips of their orders; without a waiter — split equally among those who worked.",
      pool_equal: "All period tips split equally among those who worked in the period.",
      pool_hours: "In proportion to hours worked in the period.",
    },
    total: "Tips for the period: {{amount}}",
    distribute: "Distribute",
    created: "Tips distributed",
    empty: "No tips in this period",
    basis: "Basis",
    hours: "{{h}} h",
    ownOrders: "Own orders",
    equalShare: "Equal share",
    amount: "Amount",
    pools: "Distributions",
    noPools: "No distributions yet",
    payout: "Pay out",
    payoutAll: "Pay everyone {{amount}}",
    paidOut: "Tips paid out",
    paidCash: "Paid",
    viaPayroll: "With salary",
    statuses: {
      calculated: "Distributed",
      paid: "Paid",
    },
  },
  me: {
    title: "My account",
    description: "My shifts, sales, tips and payslips.",
    onShift: "You are on shift since {{since}}",
    offShift: "You are not on shift",
    clockIn: "Start shift",
    clockOut: "End shift",
    clockedIn: "Shift started",
    clockedOut: "Shift ended",
    worked: "Worked",
    orders: "Orders",
    sales: "Sales",
    tips: "Tips",
    payslip: "Payslip {{from}} — {{to}}",
    payslipTotals: "To pay {{net}} · paid {{paid}}",
    shifts: "My shifts",
  },
  audit: {
    title: "Audit log",
    description: "Who changed what and when: prices, cancellations, refunds, cash operations, debts, shifts and payroll.",
    actionFilter: "Section",
    at: "Time",
    action: "Action",
    user: "Who",
    entity: "Object",
    system: "System",
    empty: "No records",
    before: "Before",
    after: "After",
    ...auditEn,
  },
  docs: docsEn,
  billing: {
    pageDescription: "Plan, limits, add-ons and invoices. Paid changes take effect after the invoice is paid; downgrades — from the next period.",
    plans: "Plans",
    period: "Billing period",
    periods: {
      month: "Month",
      quarter: "Quarter",
      year: "Year",
    },
    periodTill: "{{period}}, paid until {{date}}",
    current: "Current",
    choose: "Choose",
    changePeriod: "Change period",
    changeTo: "Plan “{{plan}}”",
    byContract: "By contract",
    pay: "Pay",
    save: "save {{pct}}%",
    planInvoice: {
      term: "Billing term",
      custom: "Until date",
      customHint: "Your own end date: months at the period price, remaining days pro rata",
      until: "Paid until (inclusive)",
      perMonth: "{{amount}} per month",
      saving: "{{amount}} per month · save {{pct}}% ({{save}})",
      termLine: "Term: {{from}} – {{to}}",
      trialHint: "The plan switches now; the paid term starts after the trial.",
      paidHint: "The term starts after the already paid one — from {{date}}. The plan changes once the invoice is paid.",
      noPrice: "This plan has no price — contact Coca support.",
    },
    planLimits: "Branches: {{branches}} · terminals: {{terminals}} · users: {{users}}",
    addons: "Add-ons",
    addonsHint: "Enabled right after payment; disabling — at the end of the period, data is kept.",
    addon: "Add-on",
    price: "Price per period",
    included: "Included in plan",
    active: "Enabled",
    enable: "Enable",
    enableAddon: "Enable “{{name}}”",
    disable: "Disable",
    addonCancelled: "The add-on will be disabled at the end of the period",
    endsAt: "Ends {{date}}",
    apply: "Apply",
    issueInvoice: "Issue invoice for {{amount}}",
    toPay: "To pay",
    discount: "Discount",
    afterPayment: "The change takes effect after the invoice is paid.",
    trialFree: "During the trial changes are free and take effect immediately.",
    term: {
      label: "Term",
      subscription: "With subscription",
      custom: "Custom term",
      subscriptionHint: "Until the end of the paid term — through {{date}}, then renews with the subscription.",
      subscriptionTrialHint: "First paid period — through {{date}}, then renews with the subscription.",
      from: "From",
      to: "To (inclusive)",
      months: "{{count}} mo.",
      customHint: "Paid once for the selected days; does not renew automatically.",
      past: "Not earlier than today",
      order: "Before the start date",
    },
    paidUntil: "Paid through {{date}}",
    startsAt: "From {{date}}",
    extend: "Extend",
    scheduled: "The change takes effect on {{date}} — from the next period.",
    scheduledChange: "Scheduled from the next period: plan {{plan}}, period {{period}}",
    downgradeBlocked: "Usage exceeds the new plan limits: deactivate extra branches, terminals or users.",
    addonsDropped: "Add-ons not available on the new plan will be turned off: {{names}}. Your data is kept.",
    invoiceIssued: "Invoice {{n}} issued",
    changeApplied: "Change applied",
    invoices: "Invoices",
    noInvoices: "No invoices yet",
    number: "Number",
    issued: "Issued",
    due: "Due",
    total: "Amount",
    print: "Print",
    bankTitle: "Payment details",
    invoiceStatus: {
      open: "Awaiting payment",
      paid: "Paid",
      void: "Void",
      refunded: "Refunded",
      draft: "Draft",
    },
    limitNear: "Almost used up",
    limitReached: "Used up",
    banner: {
      trial: "When it ends, choose a plan and pay the invoice.",
      past_due: "Pay the invoice by {{date}}, otherwise access becomes read-only.",
      read_only: "Read-only access: register sales work, everything else after payment. Suspension on: {{date}}.",
      suspended: "The subscription is suspended. Pay the invoice to restore access.",
      expired: "The trial has ended. Choose a plan.",
      archived: "The subscription is archived.",
      cancelled: "The subscription is cancelled and active until {{date}}.",
    },
    bannerPastDue: "The subscription awaits payment — pay the invoice to keep access.",
    bannerReadOnly: "Read-only access: the register sells, changes are unavailable until payment.",
    payNow: "Pay",
    choosePlan: "Choose a plan",
    supportReadOnly: "Coca support session — view only",
    supportFull: "Coca support session — with changes allowed",
    supportExit: "End session",
    supportLinkInvalid: "The support session link is invalid",
    inviteTitle: "Welcome to Coca",
    inviteHint: "Create a password to sign in to the ERP.",
    inviteInvalid: "The invitation link is invalid",
    inviteExpired: "Link expired? Set a password via password recovery",
    inviteSubmit: "Set password and sign in",
  },
  onboarding: {
    title: "Venue setup",
    defaultHall: "Main hall",
    next: "Next",
    back: "Back",
    skip: "Skip",
    skipped: "skipped",
    todo: "Do it",
    optional: "Optional",
    company: {
      title: "Company",
      hint: "Your business name. Legal details can be added later.",
      name: "Name",
      country: "Country",
      legalName: "Legal name",
      taxId: "Tax ID",
    },
    branch: {
      title: "Venue",
      hint: "The format sets default order types — only the plan limits features.",
      format: "Venue format",
      name: "Venue name",
      phone: "Phone",
      city: "City",
      address: "Address",
    },
    currency: {
      title: "Currency & time",
      hint: "Currency of prices and receipts, time zone and business day boundary for reports.",
      currency: "Currency",
      timezone: "Time zone",
      cutoff: "Day boundary",
      cutoffHint: "Sales before this time belong to the previous day",
    },
    menu: {
      packsTitle: "Need a full menu?", packsHint: "“Catalog → Menu packs” has packs for a shawarma place, coffee shop, ice cream café, national cuisine, pizzeria, sushi bar and other formats: dishes with photos and descriptions, products, semi-finished items and costed recipe cards. You buy each pack once.",
      title: "Menu",
      hint: "Load a demo menu for your format — prices and items can be changed or removed.",
      manual: "I will create the menu myself",
      load: "Load",
      loaded: "Demo menu loaded",
      has: "The menu already has {{n}} items",
      templates: {
        coffee: "Coffee (sizes, milk, syrups), tea, pastries, desserts",
        cafe: "Salads, soups, mains, drinks — kitchen and bar",
        fast_food: "Burgers with extras, snacks with sauces, drinks",
      },
    },
    tables: {
      title: "Tables",
      hint: "A quick floor plan: tables are arranged in a grid, each with a menu QR.",
      hall: "Hall",
      count: "Tables",
      capacity: "Seats per table",
      generate: "Create tables",
      created: "Tables created: {{n}}",
      has: "Tables already: {{n}}",
    },
    employees: {
      title: "Staff",
      hint: "Cashiers and waiters sign in at the register with a PIN — no password needed.",
      name: "Name",
      role: "Role",
      pinHint: "4–6 digits",
      add: "Add employee",
    },
    cash: {
      title: "Register",
      hint: "Open a web register shift with a float — and you can sell. Terminals are connected in Settings → Terminals.",
      open: "Open shift",
    },
    finish: {
      title: "Ready for the first sale",
      hint: "Skipped steps can be finished later in settings.",
      openPos: "Open the register",
      openDashboard: "Go to dashboard",
    },
    steps: {
      company: "Company",
      branch: "Venue",
      currency: "Currency & time",
      menu: "Menu",
      tables: "Tables",
      employees: "Staff",
      cash: "Register",
      finish: "Done",
    },
    formats: {
      cafe: "Café with waiters",
      coffee: "Coffee shop",
      fast_food: "Fast food",
      self_service: "Self-service",
      food_court: "Food court",
    },
    formatHints: {
      cafe: "Hall, tables, pay after the meal",
      coffee: "Takeaway and dine-in, drink modifiers",
      fast_food: "Order number, pay upfront",
      self_service: "Order at the counter, ready screen",
      food_court: "Shared hall, several kitchens",
    },
    countries: {
      KG: "Kyrgyzstan",
      KZ: "Kazakhstan",
      UZ: "Uzbekistan",
      TJ: "Tajikistan",
      RU: "Russia",
    },
  },
  site: {
    contacts: { title: "Contacts and social media", hint: "Shown in the site footer and on the home page. Empty fields are hidden. Social media — a link or account name (@name).", phone: "Venue phone", email: "Email for guests" },
    title: "Website & QR menu",
    description: "The venue public website, QR menus on tables and guest ordering from a phone.",
    open: "Open website",
    slug: "Website address (subdomain)",
    heroTitle: "Home page headline",
    about: "About the venue",
    seoTitle: "SEO title",
    seoTitleHint: "Up to 60 characters",
    seoDescription: "SEO description",
    seoDescriptionHint: "Up to 155 characters",
    qrOrdering: "Guest ordering via QR",
    qrOrderingHint: "Guests order from their phone, the order appears at the register immediately",
    qrOrderingAddon: "Available with the “QR ordering” add-on — enable it on the Subscription page",
    requireName: "Ask for the guest name",
    autoKitchen: "Send to the kitchen immediately",
    autoKitchenHint: "Otherwise the order waits for waiter confirmation",
    qrTitle: "Table QR codes",
    qrHint: "Table stickers: the guest scans to see the menu, order and call the waiter.",
    printAll: "Print stickers ({{n}})",
    noTables: "No tables yet — create them in Halls & tables.",
    counterQr: "QR for the counter and showcase",
    scanCaption: "Scan for the menu",
    callWaiter: "Table {{n}} is calling a waiter",
    requestBill: "Table {{n}} asks for the bill",
    domain: {
      title: "Your own website address",
      description: "Website and QR menu on your domain — e.g. navat.kg instead of the platform address.",
      addon: "Available with the “Own website address” add-on",
      addonHint: "Add it on the Subscription page — the site opens at your address, and platform links redirect there.",
      input: "Your domain",
      inputHint: "The domain must already be purchased from a registrar (e.g. navat.kg or menu.navat.kg)",
      connect: "Connect",
      none: "No own address connected.",
      pending: "Waiting for DNS setup",
      active: "Active",
      since: "Verified {{date}}",
      steps: "Add these records in your domain registrar's panel and press “Check”. DNS changes usually take 5–30 minutes, sometimes up to a day.",
      type: "Type",
      name: "Name",
      value: "Value",
      copy: "Copy",
      copied: "Copied",
      verify: "Check",
      change: "Change address",
      remove: "Disconnect address",
      removeTitle: "Disconnect your own address?",
      removeHint: "The site stays available at the platform address. You can delete the DNS records at your registrar.",
      noTxt: "The TXT record isn't visible yet. Check the name and value or wait — DNS doesn't update instantly.",
      noRouting: "The domain doesn't point to us yet (CNAME or A record). Until it does, the site won't open at this address.",
      sslHint: "A secure connection (https) turns on automatically within a few minutes after the domain points to us.",
      activeToast: "Address {{domain}} verified",
    },
  },
  supportAccess: {
    title: "Coca support requests access",
    description: "Support agent {{name}} wants to enter your account. They can't get in without your permission.",
    approve: "Allow access",
    deny: "Decline",
    mode: "Mode",
    modeReadOnly: "View only",
    modeFull: "View and edit",
    reason: "Reason",
    until: "Respond by",
    readOnlyHint: "The agent will see your account as you do but can't change anything. The session lasts up to 60 minutes and is recorded in the audit log.",
    fullHint: "The agent will be able to make changes on the owner's behalf. Allow only if you asked for help yourself. The session lasts up to 60 minutes; every action is recorded in the audit log.",
    approved: "Access allowed — the support agent can sign in within 10 minutes",
    denied: "Request declined",
  },
  support: {
    title: "Support",
    description: "Write to us — we reply here and send you a notification.",
    new: "Contact support",
    empty: "No requests yet",
    emptyHint: "If something doesn't work or you have a question — write to us, we'll help.",
    subject: "Subject",
    category: "Request type",
    body: "Message",
    bodyHint: "Describe what happened and what you expected. An order number or screen helps.",
    send: "Send",
    reply: "Reply",
    replyPlaceholder: "Your reply…",
    close: "Issue resolved",
    closeConfirm: "Close the request?",
    closeHint: "If the issue comes back — just write in the same request.",
    sent: "Request sent",
    replied: "Message sent",
    closed: "Request closed",
    you: "You",
    supportName: "Coca Support",
    number: "No. {{n}}",
    createdBy: "Author",
    updated: "Last message",
    slaNormal: "We reply within {{hours}} h",
    slaHigh: "Priority support: reply within {{hours}} h, your requests go first",
    slaUpsell: "Need it faster? Add “Priority support” — reply within 2 hours.",
    slaUpsellAction: "Subscription",
    waitUntil: "We'll reply by {{time}}",
    overdue: "Our reply is late — we're on it",
    statuses: {
      open: "Awaiting reply",
      answered: "Replied",
      closed: "Resolved",
    },
    categories: {
      question: "Question",
      problem: "Something doesn't work",
      billing: "Payment and subscription",
      idea: "Suggestion",
    },
    filterAll: "All",
    priorityHigh: "Urgent",
  },
  brand: {
    title: "Your own brand",
    description: "Your name, logo and color instead of Coca — in the app, on the website and in emails.",
    addon: "Available with the “Your own brand instead of Coca” add-on",
    addonHint: "Staff and guests see only your brand: app header, button color, website without “powered by Coca”, emails in your name.",
    name: "Name",
    nameHint: "In the header, browser tab and email signature. Empty — the company name",
    color: "Main color",
    logo: "Logo",
    logoHint: "Best: a wide PNG with a transparent background",
    colors: {
      orange: "Orange (Coca)",
      red: "Red",
      rose: "Raspberry",
      violet: "Violet",
      blue: "Blue",
      teal: "Teal",
      green: "Green",
      brown: "Brown",
    },
  },
  fraud: {
    title: "Abuse protection",
    description: "Suspicious staff actions: voids, refunds, discounts, cash shortages. Checked automatically every hour.",
    scan: "Check now",
    scanFound: "New found: {{count}}",
    scanNothing: "No new suspicious actions",
    settings: "Rules",
    alertsTab: "Alerts",
    peopleTab: "Staff",
    peopleTitle: "Who triggers alerts most",
    peopleHint: "Risk is the sum of weights: high 5, medium 3, low 1. False alarms are not counted.",
    empty: "No suspicious actions",
    emptyHint: "The rules found nothing for the selected period.",
    all: "All",
    status: "Status",
    rule: "What happened",
    employee: "Employee",
    date: "Date",
    amount: "Amount",
    risk: "Risk",
    alerts: "Alerts",
    noUser: "No employee",
    decision: "Decision",
    comment: "Comment",
    statuses: {
      new: "New",
      reviewed: "Reviewed",
      dismissed: "False alarm",
      confirmed: "Violation",
    },
    severities: {
      low: "Low",
      medium: "Medium",
      high: "High",
    },
    units: {
      count: "More than, times",
      percent: "More than, %",
      days: "Days unpaid",
      sigma: "Above average, σ",
    },
    rules: {
      void_many: "Many voided items",
      void_after_kitchen: "Item voided after the kitchen",
      cancel_after_kitchen: "Order cancelled after the kitchen",
      refunds_many: "Many refunds",
      refund_cash_for_card: "Cash refund for a card payment",
      discount_share: "Many manual discounts",
      price_below_menu: "Sold below menu price",
      writeoff_outlier: "Unusually large write-off",
      cash_shortage: "Cash shortage",
      credit_unpaid: "Unpaid debt",
    },
    ruleHints: {
      void_many: "The employee voided more items in a day than usual.",
      void_after_kitchen: "The dish was already being cooked and then voided — ingredients spent, no money.",
      cancel_after_kitchen: "The order went to the kitchen and was then cancelled.",
      refunds_many: "More refunds in a day than usual.",
      refund_cash_for_card: "The guest paid by card but the refund was given in cash — a classic cash-out scheme.",
      discount_share: "The employee's manual discounts are a noticeable share of their daily sales.",
      price_below_menu: "Items were sold below the menu price.",
      writeoff_outlier: "The write-off is much larger than usual for this venue.",
      cash_shortage: "Less cash than expected at shift close. A repeat within 30 days is serious.",
      credit_unpaid: "A credit sale with no repayments for a long time.",
    },
    d: {
      count: "{{count}} times (threshold {{threshold}})",
      order: "order No. {{n}}",
      pct: "{{pct}}% (threshold {{threshold}}%)",
      lines: "items: {{count}}",
      average: "usually about {{avg}}",
      repeats: "repeated: {{count}} in 30 days",
      customer: "customer {{name}}",
      paidBy: "paid by: {{methods}}",
    },
  },
  sms: {
    title: "SMS campaigns",
    description: "Messages to customers by segment: promotions, news, reminders. Only to those who agreed to receive them.",
    usage: "SMS for {{month}}",
    usageValue: "{{used}} of {{quota}}",
    noQuota: "No SMS this month",
    lowQuota: "SMS left: {{count}}",
    packHint: "The “SMS 1000” pack is added on the Subscription page and renews every month.",
    buyPack: "Subscription",
    new: "New campaign",
    test: "Test SMS",
    campaigns: "Campaigns",
    empty: "No campaigns yet",
    emptyHint: "Create the first one — e.g. a weekend discount invitation.",
    name: "Name",
    nameHint: "For you; customers don't see it",
    segment: "Audience",
    allCustomers: "All customers with consent",
    tag: "Customer tag",
    tagHint: "Optional: only customers with this tag",
    text: "Text",
    counter: "{{length}} chars · {{parts}} SMS ({{perPart}} each)",
    noRecipients: "No recipients: a phone and the “agrees to marketing” mark in the customer card are required.",
    previewText: "Recipients: {{recipients}}, SMS: {{total}}. Left this month: {{remaining}}.",
    notEnough: "Not enough SMS — buy a pack.",
    consentHint: "Only customers marked “agrees to marketing”, with a phone and not blocked, will receive it.",
    confirmTitle: "Send the campaign?",
    confirmText: "Recipients: {{recipients}}, SMS used: {{total}}. It can't be cancelled after sending.",
    send: "Send",
    started: "Campaign started — messages go out within a minute",
    phone: "Number",
    testText: "SMS test from our cafe",
    testQueued: "SMS is being sent",
    date: "When",
    recipients: "Recipients",
    delivered: "Delivered",
    notSent: "not sent: {{count}}",
    statuses: {
      sending: "Sending",
      sent: "Sent",
    },
  },
  services: {
    title: "Services & rentals",
    description: "Hookah, karaoke, room rental: the timer runs on the server, and when stopped the service is added to the order automatically.",
    start: "Start a service",
    startTimer: "Start timer",
    sell: "Sell",
    started: "Timer started",
    sold: "Service added to the order",
    stopped: "Service added to the order",
    tabs: {
      now: "Now",
      rooms: "Rooms",
      tariffs: "Pricing",
      report: "Report",
    },
    statuses: {
      running: "Running",
      paused: "Paused",
      stopped: "Finished",
      cancelled: "Cancelled",
    },
    pause: "Pause",
    resume: "Resume",
    stop: "Finish",
    stopTitle: "Finish and add to the order?",
    stopHint: "Time is charged by the tariff (step and rounding), the amount goes to the order.",
    cancel: "Cancel",
    cancelTitle: "Cancel without charge?",
    cancelHint: "The time won't be charged. The action is logged.",
    elapsed: "Elapsed {{time}}",
    planned: "Paid until {{time}}",
    overPlanned: "Paid time is over",
    noActive: "Nothing running now",
    noActiveHint: "Start a service — hookah, karaoke or a room rental.",
    recent: "Recent",
    when: "Started",
    duration: "Time",
    amount: "Amount",
    service: "Service",
    room: "Room",
    noRoom: "No room",
    busy: "busy",
    free: "Free",
    quantity: "Quantity",
    plannedMinutes: "Paid time, min",
    plannedHint: "Optional: the timer turns red when time is up",
    orderHint: "Without an order a new one is created — at the room's table if set.",
    noReady: "No configured services: add a menu item of type “Service” and set pricing on the “Pricing” tab.",
    billing: "How to charge",
    billingHourly: "By time",
    billingUnit: "Per unit",
    unitHint: "Price comes from the menu ({{price}}); with a recipe, ingredients (tobacco, coal) are written off.",
    hourlyPrice: "Price per hour",
    minDuration: "Minimum, min",
    step: "Step, min",
    rounding: "Rounding",
    roundings: {
      up: "Up",
      nearest: "Nearest",
      down: "Down",
    },
    tierLabel: "Different price after the first hour",
    tierHint: "E.g. first hour 1000, then 800 each",
    tierFrom: "From minute",
    tierPrice: "Hourly price after",
    commission: "Commission",
    commissions: {
      none: "No commission",
      fixed: "Amount",
      percent: "Percent",
      mixed: "Amount + percent",
    },
    commissionPercent: "Percent",
    commissionFixed: "Amount",
    addRoom: "Add room",
    roomName: "Name",
    minOrder: "Minimum order",
    minOrderHint: "When the rental ends, the order is topped up to this amount",
    deposit: "Deposit",
    roomActive: "In use",
    inactive: "Off",
    noRooms: "No rooms yet",
    noRoomsHint: "Add a VIP room or a karaoke hall.",
    tariffsHint: "Services are menu items of type “Service”. Here you set how they're charged and the performer's commission.",
    noServices: "No services yet",
    noServicesHint: "Create a menu item of type “Service”.",
    notConfigured: "Not configured",
    perHour: "{{price}} per hour, step {{step}} min",
    perUnit: "{{price}} each",
    revenue: "Revenue",
    roomsLoad: "Room occupancy",
    hours: "Hours",
    sessions: "Sessions",
    load: "Occupancy",
    commissionsTitle: "Staff commissions",
    commissionsHint: "Refunds and voided items are excluded.",
    noCommissions: "No commissions",
    employee: "Employee",
    sales: "Sales",
  },
  banquets: {
    title: "Banquets",
    description: "Weddings, birthdays, corporate events: per-guest menu, deposits, hall booking and the order on the event day.",
    new: "New banquet",
    empty: "No banquets",
    emptyHint: "Create an inquiry — the menu and deposit can be added later.",
    name: "Name",
    type: "Type",
    startsAt: "Start",
    endsAt: "End",
    guests: "Guests",
    guestsN: "Guests: {{count}}",
    halls: "Halls",
    hallsHint: "Once confirmed, the halls are closed for regular reservations",
    depositRequired: "Deposit to confirm",
    depositRequiredHint: "0 — confirm without a deposit",
    notes: "Notes",
    types: {
      wedding: "Wedding",
      birthday: "Birthday",
      corporate: "Corporate",
      anniversary: "Anniversary",
      other: "Other",
    },
    statuses: {
      inquiry: "Inquiry",
      tentative: "Tentative",
      confirmed: "Confirmed",
      in_progress: "In progress",
      completed: "Completed",
      cancelled: "Cancelled",
    },
    statusActions: {
      inquiry: "To inquiries",
      tentative: "Tentative",
      confirmed: "Confirm",
      in_progress: "Start",
      completed: "Complete",
      cancelled: "Cancel",
    },
    cancelTitle: "Cancel the banquet?",
    cancelHint: "The halls are released. Refund remaining deposits on the “Deposits” tab.",
    cancelReason: "Cancelled in ERP",
    start: "Start banquet",
    startTitle: "Start the banquet?",
    startHint: "An order is created from the menu, the deposit is applied to payment. An open cash shift is required.",
    started: "Banquet order created",
    complete: "Complete",
    completed: "Banquet completed",
    print: "Proposal",
    proposal: "Commercial proposal",
    orderN: "Order No. {{n}}",
    tabs: {
      menu: "Menu",
      deposits: "Deposits",
      summary: "Summary",
    },
    addItem: "Add dish",
    menuEmpty: "The menu is empty",
    menuEmptyHint: "Add dishes — quantity can be set per guest.",
    dish: "Dish",
    course: "Course",
    qty: "Qty",
    perGuest: "per guest",
    price: "Price",
    sum: "Amount",
    menuTotal: "Total {{total}} · per guest {{perGuest}}",
    depositState: "Paid {{paid}} of {{required}}; applied to the order {{applied}}",
    depositAmount: "Deposit amount",
    method: "Method",
    methods: {
      cash: "Cash",
      card: "Card",
      bank: "Transfer",
    },
    takeDeposit: "Receive",
    depositAdded: "Deposit received",
    noDeposits: "No deposits",
    when: "When",
    refunded: "Refunded",
    refund: "Refund",
    refundTitle: "Refund the deposit?",
    refundHint: "{{amount}} — cash is paid out from the till.",
    menuSum: "Menu",
    orderSum: "Order No. {{n}}",
    costSum: "Cost by recipes",
    costPartial: "not all dishes have recipes",
    extraCosts: "Extra costs",
    profit: "Profit",
    deposits: "Deposits",
    due: "Due",
    productsTitle: "Products for the banquet",
    productsHint: "By menu recipes for all guests; how much to buy beyond stock.",
    missingRecipes: "No recipe: {{names}}",
    noProducts: "No dishes with recipes",
    product: "Product",
    need: "Needed",
    inStock: "In stock",
    toBuy: "To buy",
  },
  promotions: {
    title: "Promotions",
    description: "Rule-based discounts: happy hours, combos, “2+1”, gifts, promo codes. Compatibility by priority and groups.",
    posHint: "At the POS, promotions are turned on with the “Promotions” button on the order — the promo code is entered there too.",
    new: "New promotion",
    empty: "No promotions yet",
    emptyHint: "E.g. “Beer −30% from 5 to 7 pm” or “Burger + fries + drink = 450”.",
    tabs: {
      list: "Promotions",
      report: "What they cost",
    },
    name: "Name",
    code: "Promo code",
    codeHint: "Optional: the promotion works only with this code",
    type: "Type",
    types: {
      percent: "Percent discount",
      fixed: "Amount discount",
      combo: "Combo at a special price",
      bogo: "Buy X get Y",
      gift: "Gift",
    },
    percent: "Percent",
    amount: "Discount amount",
    buyQty: "Buy",
    getQty: "Get",
    getPercent: "Discount on “get”, %",
    slot: "Slot {{n}}",
    addSlot: "Slot",
    removeSlot: "Remove slot",
    comboPrice: "Set price",
    gift: "Gift",
    giftHint: "The item must be in the order — it becomes free",
    target: "Applies to",
    scopes: {
      order: "Whole order",
      categories: "Categories",
      items: "Items",
    },
    conditions: "Conditions",
    minSubtotal: "Order from",
    days: "Weekdays",
    daysHint: "Empty — every day",
    timeFrom: "From",
    timeTo: "To",
    timeHint: "Happy hours; across midnight is fine",
    dateFrom: "Valid from",
    dateTo: "Valid to",
    customerTag: "Customer tag",
    customerTagHint: "E.g. staff — staff discount",
    usageLimit: "Usage limit",
    firstOrder: "Customer's first order only",
    stackGroup: "Compatibility group",
    stackGroupHint: "One per group applies — the most beneficial",
    priority: "Priority",
    exclusive: "Exclusive",
    exclusiveHint: "If it applies, other promotions don't",
    active: "Active",
    on: "Active",
    off: "Off",
    orders: "Orders",
    cost: "Discount",
    revenue: "Order revenue",
    reportEmpty: "No promotions applied in the period",
    deleteTitle: "Delete the promotion?",
    fromSum: "from {{sum}}",
    limitN: "limit {{n}}",
  },
  deliveries: {
    formatOff: "The branch doesn't do delivery",
    formatOffHint: "Turn on the “Delivery” format in the branch settings — without it a delivery order can't be created.",
    formatOffAction: "Branch settings",
    title: "Delivery",
    description: "Dispatch: orders by status, timers to the promised time, couriers and zones.",
    new: "New delivery",
    createAndOpen: "Create and open in POS",
    created: "Delivery created — add the items",
    empty: "No active deliveries",
    emptyHint: "Create a delivery — items are added at the POS.",
    tabs: {
      board: "Active",
      done: "Completed",
      zones: "Zones",
      couriers: "Couriers",
    },
    statuses: {
      new: "New",
      confirmed: "Confirmed",
      cooking: "Cooking",
      ready: "Ready",
      courier_assigned: "Courier assigned",
      on_the_way: "On the way",
      delivered: "Delivered",
      failed: "Failed",
      cancelled: "Cancelled",
      returned: "Returned",
    },
    statusActions: {
      new: "New",
      confirmed: "Confirm",
      cooking: "Cooking",
      ready: "Ready",
      courier_assigned: "Assign",
      on_the_way: "On the way",
      delivered: "Delivered",
      failed: "Failed",
      cancelled: "Cancel",
      returned: "Returned",
    },
    payments: {
      prepaid: "Paid",
      cash: "Cash to courier",
      card: "Card to courier",
    },
    changeFrom: "change from {{sum}}",
    changeFromLabel: "Change from a note",
    lateBy: "{{n}} min late",
    leftN: "{{n}} min left",
    noItems: "no items yet",
    noCourier: "No courier",
    courier: "Courier",
    openPos: "In POS",
    reasonHint: "The action is logged.",
    byDispatcher: "Marked by dispatcher",
    customer: "Guest name",
    phone: "Phone",
    street: "Street, building",
    entrance: "Entrance",
    floor: "Floor",
    apartment: "Apartment",
    comment: "Note for the courier",
    zone: "Zone",
    zoneHint: "Detected from coordinates",
    noZone: "No zone (manual fee)",
    coords: "Coordinates",
    coordsHint: "Latitude, longitude — from maps (optional)",
    payment: "Payment",
    scheduledAt: "Scheduled for",
    scheduledHint: "Empty — as soon as possible",
    entranceN: "entrance {{n}}",
    floorN: "floor {{n}}",
    aptN: "apt. {{n}}",
    address: "Address",
    promised: "Promised",
    newZone: "New zone",
    zoneName: "Name",
    zoneKind: "Shape",
    kinds: {
      circle: "Circle",
      polygon: "Polygon",
    },
    center: "Center",
    radius: "Radius, m",
    polygon: "Vertices",
    polygonHint: "One per line: latitude, longitude",
    fee: "Fee",
    freeFrom: "Free from",
    freeFromHint: "0 — always charged",
    minOrder: "Min. order",
    eta: "Delivery time, min",
    zoneActive: "Active",
    off: "Off",
    noZones: "No zones yet",
    noZonesHint: "Without zones the address isn't checked — the fee is set manually.",
    radiusN: "radius {{n}} m",
    pointsN: "{{n}} points",
    freeFromN: "free from {{sum}}",
    minN: "{{n}} min",
    noCouriers: "No couriers",
    noCouriersHint: "Add an employee with the “Courier” role.",
    activeN: "Active",
    onHand: "Cash on hand",
    handover: "Receive cash",
    handoverTitle: "Receive cash from {{name}}?",
    handoverHint: "The courier hands over {{sum}}.",
    handedOver: "Cash received",
    reportTitle: "Courier report",
    noData: "No data",
    delivered: "Delivered",
    lateCount: "Late",
    failedCount: "Failed",
    avgTime: "Average time",
    cash: "Cash",
  },
  courier: {
    title: "My deliveries",
    description: "Orders assigned to you: address, call, route and status.",
    empty: "No deliveries",
    emptyHint: "When the dispatcher assigns an order, it appears here.",
    paid: "Paid",
    collectCash: "Collect cash {{sum}}",
    collectCard: "Card payment {{sum}}",
    call: "Call",
    route: "Route",
    go: "On my way",
    delivered: "Delivered",
    failed: "Failed",
    failTitle: "Couldn't deliver?",
    failHint: "The dispatcher will see the reason and decide what to do.",
    failReason: "Couldn't hand over",
    deliveredToast: "Marked as delivered",
  },
  ai: {
    "quota": {
      "left": "{{remaining}} of {{limit}} requests left this month",
      "more": "Add requests",
      "exhausted": "Coca AI requests for this month are used up. Add the «+500 assistant requests» pack in «Subscription» or wait for next month."
    },
    "hint": {
      "title": "Coca AI tip",
      "updated": "Updated {{time}}",
      "get": "Get a tip",
      "refresh": "Refresh tip (1 request)",
      "hide": "Hide",
      "topics": {
        "sales": "What matters in sales for the period — 1 request",
        "menu": "What to change in the menu — 1 request",
        "writeoffs": "How to reduce write-offs — 1 request",
        "products": "Where products are overused — 1 request",
        "waiters": "How the team is doing — 1 request",
        "finance": "Where the money goes — 1 request",
        "stock": "What to reorder — 1 request"
      }
    },
    "button": "Coca AI — coming soon",
    "title": "Coca AI",
    "soon": "Soon",
    "eyebrow": "Coca AI · coming soon",
    "heroTitle": "Your restaurant gets",
    "heroAccent": "a mind of its own",
    "heroText": "A copilot that sees every check, every shift and every gram in stock. It predicts, advises and acts before you even ask.",
    "explore": "See what it can do",
    "notify": "Notify me first",
    "notified": "You're on the early list",
    "notifyDone": "Done! You'll be the first to know when Coca AI launches.",
    "featuresTitle": "Superpowers for",
    "featuresAccent": "your whole team",
    "featuresText": "A neural network trained on your venue's data: menu, sales, stock, staff and guests in one picture.",
    "finalEyebrow": "The future of hospitality",
    "soonBig": "Soon",
    "finalText": "We're training Coca AI right now. Sign up and your venue will be among the first to get access.",
    "chat": {
      "button": "Coca AI assistant",
      "eyebrow": "Coca AI · beta",
      "ask": "Ask a question",
      "text": "Ask about sales, menu, waiters, write-offs or stock — the assistant checks your branch reports and answers with numbers. It sees only what your role allows.",
      "subtitle": "Answers from your branch data",
      "live": "Live",
      "hello": "Hi! I can look at this branch's reports. Try asking:",
      "suggestions": {
        "yesterday": "How did yesterday go?",
        "menu": "Which dishes sold worst this month?",
        "stock": "What is running low in stock?",
        "waiters": "Which waiter did best this week?"
      },
      "placeholder": "Your question…",
      "send": "Send",
      "clear": "Start over",
      "voice": "Voice input",
      "voiceStop": "Stop recording",
      "voiceDenied": "No microphone access — allow it in your browser settings.",
      "voiceFailed": "Could not recognize speech. Please try again.",
      "thinking": "Checking the data…",
      "sources": "Looked at",
      "tools": {
        "sales_report": "sales",
        "menu_report": "sales by dish",
        "waiters_report": "waiters",
        "writeoffs_report": "write-offs",
        "products_report": "products",
        "finance_report": "finance",
        "low_stock": "stock"
      },
      "empty": "Couldn't come up with an answer. Try rephrasing.",
      "notConfigured": "The assistant is not connected: no AI key (Claude or Gemini) is set on the server.",
      "unavailable": "The assistant is temporarily unavailable. Try again in a minute.",
      "disclaimer": "Answers are generated by AI — check important decisions against reports."
    },
    "demo": {
      "eyebrow": "Just ask",
      "heading": "Talk to your business in plain language",
      "text": "No filters, no exports. Ask a question like you would ask your manager — Coca AI answers with numbers, reasons and a ready action plan.",
      "title": "Coca AI",
      "subtitle": "Analyst, chef and marketer in one window",
      "thinking": "AI is thinking",
      "dialogs": {
        "revenue": {
          "q": "Why was Tuesday's revenue 18% lower?",
          "a": "The average check held steady, but the evening had 40 fewer guests: rain and a football match. On similar days the \"dinner for two\" combo works — launch it next Tuesday?"
        },
        "purchase": {
          "q": "What should I order for the weekend?",
          "a": "Forecast: +35% vs weekdays. Beef — 14 kg, cream — 9 L, salmon — 6 kg. Draft orders are ready, just confirm."
        },
        "menu": {
          "q": "Which dishes should I remove from the menu?",
          "a": "3 items rarely sell and barely make a margin. \"Shrimp pasta\" is your star: move it up the menu and its profit could grow by 12%."
        }
      }
    },
    "features": {
      "forecast": {
        "title": "Demand forecast",
        "text": "Predicts guests, revenue and kitchen load by the hour, factoring in weather, holidays and city events.",
        "tag": "Predictive analytics"
      },
      "purchasing": {
        "title": "Auto purchasing",
        "text": "Works out what and how much to order so nothing runs out and nothing goes to waste.",
        "tag": "Zero waste"
      },
      "menu": {
        "title": "AI menu chef",
        "text": "Finds the stars and dead weight of your menu, suggests prices and new dishes from what's already in stock.",
        "tag": "Menu engineering"
      },
      "fraud": {
        "title": "Abuse radar",
        "text": "Spots suspicious voids, discounts and shortages before they become a habit.",
        "tag": "24/7 protection"
      },
      "staff": {
        "title": "Smart scheduling",
        "text": "Builds shifts around the load forecast: enough people at peak, no extras in quiet hours.",
        "tag": "Lower payroll"
      },
      "marketing": {
        "title": "Marketing on autopilot",
        "text": "Segments guests, writes SMS and offers for each of them and picks the best moment to send. Brings back those who haven't visited in a while.",
        "tag": "Personalization"
      },
      "voice": {
        "title": "Voice assistant",
        "text": "The waiter says the order — the POS writes it down. Hands free, fewer mistakes.",
        "tag": "Voice → order"
      }
    },
    "stats": {
      "title": "The goals we're training Coca AI for",
      "waste": {
        "value": "−30%",
        "label": "food waste"
      },
      "check": {
        "value": "+15%",
        "label": "average check"
      },
      "hours": {
        "value": "10 h",
        "label": "saved per week for a manager"
      },
      "always": {
        "value": "24/7",
        "label": "always on, no days off"
      }
    },
    "steps": {
      "title": "How it works",
      "data": {
        "title": "Data",
        "text": "Sales, stock, shifts and guests are already in Coca — nothing to set up."
      },
      "brain": {
        "title": "Intelligence",
        "text": "The model finds patterns you can't see in spreadsheets and explains them in plain words."
      },
      "action": {
        "title": "Action",
        "text": "Every tip comes with a button: order, launch an offer, adjust the schedule. You always decide."
      }
    }
  },
  "warehouse": {
    "warehouse": "Warehouse",
    "pick": "Warehouse",
    "kinds": {
      "main": "Main",
      "kitchen": "Kitchen",
      "bar": "Bar",
      "central": "Central",
      "other": "Other"
    },
    "title": "Warehouses",
    "description": "Stock is kept per warehouse. Sales are deducted from the main warehouse by recipes; the kitchen and bar receive goods by transfer.",
    "add": "Add warehouse",
    "editTitle": "Warehouse",
    "name": "Name",
    "namePlaceholder": "Hot kitchen",
    "kind": "Purpose",
    "mainKindHint": "The main warehouse's purpose can't be changed",
    "negative": "Allow negative stock",
    "negativeHint": "Write-offs and transfers above the balance won't be blocked",
    "negativeShort": "Negative allowed",
    "makeDefault": "Make main",
    "defaultHint": "Sales by recipes will be deducted from this warehouse",
    "default": "Main",
    "defaultChanged": "Main warehouse: {{name}}",
    "deleteTitle": "Delete warehouse “{{name}}”?",
    "deleteHint": "Only an empty warehouse with no transfers in transit can be deleted.",
    "count": "Warehouses: {{count}}",
    "limit": "plan limit — {{n}}",
    "products": "Products in stock",
    "openStock": "Stock",
    "onlyMain": "Only the main warehouse so far",
    "onlyMainHint": "Add a kitchen, bar or central warehouse and move goods between them."
  },
  "expiry": {
    "title": "Expiry dates",
    "description": "Batches with expiry dates across the branch's warehouses. Sales and write-offs take what expires first.",
    "expired": "Expired batches",
    "soon": "Expiring in {{n}} d",
    "filter": "Show",
    "states": {
      "expired": "Expired",
      "soon": "Expiring soon",
      "dated": "All with a date",
      "all": "All batches"
    },
    "days": "Period",
    "inDays": "within {{count}} d",
    "received": "Received",
    "expiresAt": "Best before",
    "noDate": "No date",
    "overdue": "Expired {{count}} d ago",
    "today": "Expires today",
    "left": "{{count}} d left",
    "writeoff": "Write off",
    "writeoffTitle": "Write off “{{name}}”?",
    "writeoffHint": "{{qty}} worth {{sum}} will be written off. Batches with the nearest date go first.",
    "writeoffComment": "Best before {{date}}",
    "writtenOff": "Written off",
    "empty": "No batches are expiring",
    "emptyExpired": "No expired batches",
    "emptyHint": "Enter the expiry date when purchasing, or set the product's shelf life — it will be filled in automatically."
  },
  "transfers": {
    "title": "Transfers",
    "description": "Goods between warehouses: within the branch — instantly, to another branch — “in transit” until received.",
    "new": "New transfer",
    "from": "From",
    "to": "To",
    "pickBoth": "Choose both warehouses",
    "addLines": "Add products and quantities",
    "send": "Send",
    "move": "Move",
    "externalHint": "Warehouse of “{{branch}}”: goods go “in transit”; the recipient's stock appears after receiving.",
    "internalHint": "Your branch's warehouse: goods move instantly.",
    "doneInternal": "Transfer #{{n}} posted",
    "doneSent": "Transfer #{{n}} sent to “{{branch}}”",
    "titleN": "Transfer #{{n}}",
    "sent": "Sent",
    "received": "Received",
    "receive": "Receive",
    "receiveHint": "Check the quantities: if less arrived, enter the actual amount — the shortage will be recorded.",
    "receiveComment": "Receiving comment",
    "receiveCommentPlaceholder": "E.g.: package damaged",
    "receivedToast": "Transfer #{{n}} received",
    "cancel": "Cancel transfer",
    "cancelTitle": "Cancel transfer #{{n}}?",
    "cancelHint": "Goods will return to the sending warehouse.",
    "print": "Act",
    "actTitle": "Transfer act #{{n}}",
    "signFrom": "Released by",
    "signTo": "Received by",
    "shipped": "Sent",
    "receivedAt": "Received",
    "shortage": "Shortage",
    "shortageNote": "Shortage on receiving: {{sum}}.",
    "statuses": {
      "in_transit": "In transit",
      "received": "Received",
      "cancelled": "Cancelled"
    },
    "incoming": "Incoming transfers: {{count}}",
    "incomingHint": "Goods were sent to your branch — receive them so they appear in stock.",
    "showIncoming": "Show",
    "direction": "Direction",
    "dirAll": "All",
    "dirIn": "Incoming",
    "dirOut": "Outgoing",
    "allStatuses": "All statuses",
    "route": "Route",
    "empty": "No transfers yet",
    "emptyHint": "Move products from the warehouse to the kitchen or to another branch."
  },
  "production": {
    "suggest": "Suggest plan",
    "suggestComment": "By forecast",
    "suggestCreated": "Orders planned: {{count}}",
    "suggestTitle": "Plan for {{date}} by forecast",
    "suggestHint": "Average usage on the same weekday over {{weeks}} wk + {{pct}}% buffer − stock in warehouses − already planned.",
    "suggestCreate": "Plan: {{count}}",
    "suggestEmpty": "No semi-finished products with a recipe",
    "suggestEmptyHint": "Create a “Semi-finished” product and publish its recipe.",
    "suggestSales": "Usage by week",
    "suggestAvg": "Forecast",
    "suggestHave": "In stock and planned",
    "suggestMake": "Make",
    "title": "Production",
    "description": "Semi-finished goods by recipes: a daily plan, output with exact cost, expiry dates and labels.",
    "new": "Plan production",
    "newHint": "Choose a semi-finished product with a recipe and how much to make — raw material needs are calculated automatically.",
    "plan": "Plan",
    "product": "Semi-finished product",
    "productHint": "Type “Semi-finished” with a published recipe",
    "productPlaceholder": "Dough, sauce, stock…",
    "qty": "How much to make",
    "date": "Date",
    "rawWarehouse": "Raw materials warehouse",
    "outWarehouse": "Output warehouse",
    "requirements": "Raw materials needed",
    "estTotal": "Estimated cost",
    "shortagesTitle": "Products missing: {{count}}",
    "shortagesHint": "Buy or move products to the raw materials warehouse before output.",
    "fillProduct": "Choose a semi-finished product and quantity",
    "created": "Order #{{n}} planned",
    "raw": "Raw material",
    "semi": "SF",
    "need": "Needed",
    "used": "Used",
    "cost": "Cost",
    "available": "In stock",
    "short": "Missing {{qty}}",
    "enough": "Enough",
    "estCost": "Estimate",
    "completeTitle": "Output: {{name}}",
    "completeHint": "Raw materials are deducted from the warehouse; the semi-finished product arrives as a batch with an expiry date.",
    "complete": "Post output",
    "actual": "Actual output",
    "planned": "Plan: {{qty}}",
    "expiresAt": "Best before",
    "shelfLife": "Product shelf life: {{count}} d",
    "noShelfLife": "The product has no shelf life set",
    "deviation": "Output deviation from plan: {{pct}}%",
    "customUsage": "Usage differed from the recipe",
    "customUsageHint": "Enter how much raw material was actually used",
    "shortWarn": "There is less raw material in stock than needed: output will fail unless the warehouse allows negative stock.",
    "fillActual": "Enter the actual output",
    "completedToast": "Output #{{n}} posted",
    "start": "Start",
    "cancel": "Cancel",
    "cancelTitle": "Cancel order #{{n}}?",
    "cancelHint": "Stock won't change.",
    "cancelDoneTitle": "Cancel output #{{n}}?",
    "cancelDoneHint": "Raw materials return to stock and the semi-finished product is deducted. If it was already used, cancelling will fail.",
    "statuses": {
      "planned": "Planned",
      "in_progress": "In progress",
      "completed": "Done",
      "cancelled": "Cancelled"
    },
    "planShort": "Plan",
    "fact": "Actual",
    "rawCost": "Raw material cost",
    "unitCost": "Cost per {{unit}}",
    "unitCostShort": "Unit cost",
    "lowYield": "Output is {{pct}}% below plan — check portions and losses.",
    "label": "Label",
    "labelHint": "Name, production date, best before {{date}}, cook",
    "copies": "Copies",
    "printLabel": "Print labels",
    "labelMade": "Made",
    "labelUntil": "Best before",
    "labelQty": "Qty",
    "labelBy": "Cook",
    "createdBy": "Created: {{name}}, {{at}}",
    "completedBy": "Posted: {{name}}, {{at}}",
    "yield": "Output {{pct}}%",
    "prevDay": "Previous day",
    "nextDay": "Next day",
    "today": "Today",
    "addToPlan": "Add to plan",
    "emptyDay": "Nothing planned for this day",
    "emptyDayHint": "Plan your prep — the kitchen will see it here.",
    "emptyColumn": "Empty",
    "allStatuses": "All statuses",
    "planFact": "Plan / actual",
    "empty": "No production orders",
    "tabPlan": "Daily plan",
    "tabHistory": "All orders",
    "tabReport": "Report",
    "repOrders": "Outputs",
    "repLowYield": "Items below planned output",
    "repYield": "Output",
    "repEmpty": "No output in this period"
  },
  "promo": {
    "badge": "Add-on · not connected",
    "genericTagline": "“{{name}}” isn't included in your plan. Connect it and the section works right away.",
    "connect": "Connect",
    "connectFor": "Connect for {{price}} a month",
    "changePlan": "Change plan",
    "openSubscription": "Open subscription",
    "askOwner": "The owner or an administrator can connect it — ask them to open “Subscription”.",
    "allAddons": "All add-ons",
    "inPlans": "Included in: {{plans}}",
    "fineprint": "We'll show the amount first — it connects only after you confirm. You can turn it off at any time.",
    "insideTitle": "What's inside",
    "bandTitle": "Ready to try?",
    "bandText": "“{{name}}” turns on in a minute — your data and settings are kept.",
    "items": {
      "inventory_pro": {
        "title": "Zero-loss stock: multiple warehouses, expiry dates and transfers",
        "tagline": "Kitchen, bar and central warehouse — each with its own stock. The system tracks expiry dates, uses what spoils first, and moves goods between locations in a couple of clicks.",
        "b1": {
          "t": "Expiry dates under control",
          "d": "Every batch remembers its date. Each morning you get a list of what's expiring, and sales use the oldest first."
        },
        "b2": {
          "t": "Multiple warehouses",
          "d": "Main warehouse, kitchen, bar, the chain's central warehouse — stock and value shown separately for each."
        },
        "b3": {
          "t": "Transfers between locations",
          "d": "Warehouse → kitchen instantly; to another branch “in transit” until received. Shortages are recorded automatically."
        },
        "b4": {
          "t": "Less waste, more profit",
          "d": "See what's about to go to waste and how much it's worth — use it in time or put it in a promotion."
        },
        "f1": "FEFO: what expires first goes first",
        "f2": "Batch date: on purchase or automatically from shelf life",
        "f3": "“Expiring” alerts in the app and Telegram",
        "f4": "Transfers with a printable act",
        "f5": "Stock and movement card per warehouse",
        "f6": "Stocktaking of a single warehouse",
        "who": "For venues with a kitchen and bar, chains with a central warehouse and anyone handling perishables."
      },
      "production": {
        "title": "Semi-finished production",
        "tagline": "Dough, sauces, stocks and prep — by recipe, with exact cost and expiry date. The cook sees the daily plan, and you see what every kilogram cost.",
        "b1": {
          "t": "Daily plan",
          "d": "The kitchen sees what to prep today and how much: planned → in progress → done."
        },
        "b2": {
          "t": "Cost to the cent",
          "d": "Raw materials are deducted by recipe; semi-finished cost = raw material cost ÷ actual output. It feeds into dish costs too."
        },
        "b3": {
          "t": "Output control",
          "d": "The deviation of actual from planned output is visible at once — you see where product is lost."
        },
        "b4": {
          "t": "Labels and expiry",
          "d": "Each batch gets an expiry date; the label prints in one click: name, date, expiry, cook."
        },
        "f1": "Raw material needs and shortages before you start",
        "f2": "Output in one action: raw materials deducted, product in stock",
        "f3": "Custom raw usage if it differed from the recipe",
        "f4": "Sales deduct the ready product, not flour and water",
        "f5": "Report: plan, actual, output deviation, cost",
        "f6": "Cancelling output reverses it and returns raw materials",
        "who": "For pizzerias, bakeries, cafés with prep and kitchens that make sauces and semi-finished goods in advance."
      },
      "procurement": {
        "title": "Purchasing and suppliers",
        "tagline": "All suppliers, their invoices, due dates and debts in one window. No notebooks, no forgotten payments.",
        "b1": {
          "t": "Supplier debts under control",
          "d": "How much, to whom and by when — with overdue reminders."
        },
        "b2": {
          "t": "Payments and advances",
          "d": "Cash from the register or bank transfer, in parts or in advance — it all reconciles itself."
        },
        "b3": {
          "t": "Returns to suppliers",
          "d": "Returned goods reduce the debt automatically at purchase prices."
        },
        "b4": {
          "t": "Reconciliation in a minute",
          "d": "Print a reconciliation statement for any period and settle questions with the supplier."
        },
        "f1": "Supplier directory with payment terms",
        "f2": "A purchase = a supplier invoice with a due date",
        "f3": "Due date and overdue alerts",
        "f4": "Goods returns and supplier refunds",
        "f5": "What you bought from each supplier and at what price",
        "f6": "A4 reconciliation statement",
        "who": "For everyone who works with suppliers on credit or deferred payment."
      },
      "finance": {
        "title": "Venue finances",
        "tagline": "Profit, expenses and cash flow — every day, not at the end of the month. See where the money goes and how much you really earn.",
        "b1": {
          "t": "Profit for any period",
          "d": "Revenue, cost of goods, payroll, rent and other expenses in one report."
        },
        "b2": {
          "t": "Expenses by category",
          "d": "Rent, utilities, marketing — entered in seconds, the report does the math."
        },
        "b3": {
          "t": "Cash flow",
          "d": "What came in and went out in cash and cashless, what you're owed and what you owe."
        },
        "b4": {
          "t": "Decisions based on numbers",
          "d": "Clear what to cut and what to grow."
        },
        "f1": "Profit and loss report",
        "f2": "Expenses by category and branch",
        "f3": "Payroll and tips are included automatically",
        "f4": "Guest and supplier debts in cash flow",
        "f5": "Cash register expenses appear in the report at once",
        "who": "For owners who want to know real profit, not just revenue."
      },
      "fraud": {
        "title": "Abuse protection",
        "tagline": "Every hour the system checks voids, discounts, refunds and shortages and reports anything suspicious right away. Your register is watched even when you're not there.",
        "b1": {
          "t": "Suspicious activity at a glance",
          "d": "Voids after the kitchen, cash refunds for card payments, excessive discounts — in one feed."
        },
        "b2": {
          "t": "Risk per employee",
          "d": "Each employee has a risk score: you see who to keep an eye on."
        },
        "b3": {
          "t": "Telegram alerts",
          "d": "Serious issues instantly, a summary once a week."
        },
        "b4": {
          "t": "Your rules",
          "d": "Thresholds for each rule are tuned to your venue."
        },
        "f1": "Item voids and cancellations after the kitchen",
        "f2": "Refunds, including cash for card payments",
        "f3": "Share of manual discounts and sales below menu price",
        "f4": "Unusually large write-offs",
        "f5": "Cash shortages and their repeats",
        "f6": "Decisions: reviewed, false alarm, confirmed",
        "who": "For owners who can't be at the venue every day."
      },
      "sms": {
        "title": "SMS campaigns to guests",
        "tagline": "Remind guests about yourself at the right moment: a promotion, a new menu, birthday greetings. Send to chosen guests in a couple of clicks.",
        "b1": {
          "t": "Right on target",
          "d": "Segments and tags: regulars, haven't visited in a while, this week's birthdays."
        },
        "b2": {
          "t": "Consent only",
          "d": "Messages go only to guests who agreed to receive them."
        },
        "b3": {
          "t": "Transparent usage",
          "d": "See how many SMS are left this month; you'll be warned at 80% and 100%."
        },
        "b4": {
          "t": "Bring guests back",
          "d": "A short offer by SMS — and the guest is back."
        },
        "f1": "Send to a segment or tag",
        "f2": "Birthday greetings",
        "f3": "SMS parts counted before sending",
        "f4": "Test SMS to yourself",
        "f5": "Delivery statuses",
        "who": "For venues with a guest base who want to see regulars more often."
      },
      "services": {
        "title": "Services and rentals",
        "tagline": "Karaoke, billiards, hookah, VIP rooms — hourly billing with a server-side timer; minimum spend and staff commissions are calculated automatically.",
        "b1": {
          "t": "A timer everyone trusts",
          "d": "Time runs on the server, pauses are counted — no arguments with guests."
        },
        "b2": {
          "t": "Flexible rates",
          "d": "Hourly price, rounding step, minimum, tiers and scheduled prices."
        },
        "b3": {
          "t": "Room minimum spend",
          "d": "Fell short — the top-up is added to the bill automatically."
        },
        "b4": {
          "t": "Staff commissions",
          "d": "Fixed, percentage or mixed — straight into the report."
        },
        "f1": "Hourly and per-unit services",
        "f2": "Rooms with minimum spend",
        "f3": "Pause and resume sessions",
        "f4": "Service goes straight into the guest's bill",
        "f5": "Staff commissions and report",
        "who": "For karaoke, lounge bars, billiard halls, hookah bars and venues with VIP rooms."
      },
      "banquets": {
        "title": "Banquets and events",
        "tagline": "From inquiry to the final bill: per-guest menu, deposits, hall bookings and cost — all in one banquet card.",
        "b1": {
          "t": "No inquiry gets lost",
          "d": "Inquiry → tentative → confirmed → in progress → completed."
        },
        "b2": {
          "t": "Deposits without confusion",
          "d": "The deposit is taken and applied to the banquet bill automatically."
        },
        "b3": {
          "t": "No double-booked halls",
          "d": "A confirmed banquet blocks the hall for reservations."
        },
        "b4": {
          "t": "Cost and products",
          "d": "See the banquet margin and how many products to buy right away."
        },
        "f1": "Per-guest and per-table menu",
        "f2": "Deposits in cash and by transfer",
        "f3": "Printable proposal",
        "f4": "Product needs by recipes",
        "f5": "Banquet order on the register in one click",
        "who": "For restaurants, banquet halls and cafés hosting celebrations and corporate events."
      },
      "promotions_pro": {
        "title": "Promotions and promo codes",
        "tagline": "Happy hours, combos, “second one free”, gifts and promo codes — the register applies the best promotion itself, with no cashier mistakes.",
        "b1": {
          "t": "Any mechanic",
          "d": "Percentage or fixed discount, combo, “1+1”, a gift with the order."
        },
        "b2": {
          "t": "Precise conditions",
          "d": "Weekdays, hours, dates, branches, order type, first order, guest tag."
        },
        "b3": {
          "t": "No conflicts",
          "d": "Exclusive and compatible promotions: the guest gets the best one."
        },
        "b4": {
          "t": "Results in numbers",
          "d": "Report: how often a promotion fired and what it cost."
        },
        "f1": "Happy hours, including past midnight",
        "f2": "Promo codes with limits",
        "f3": "Combo sets and “1+1”",
        "f4": "Gift with order",
        "f5": "Promotions report",
        "who": "For venues that want to fill quiet hours and raise the average check."
      },
      "delivery": {
        "title": "Own delivery",
        "tagline": "Zones on the map, couriers, statuses and couriers' cash — delivery runs like clockwork and guests see their order status.",
        "b1": {
          "t": "Zones and pricing",
          "d": "Polygons and radii, minimum order, free delivery above an amount."
        },
        "b2": {
          "t": "Delivery board",
          "d": "New → cooking → on the way → delivered: timers show delays."
        },
        "b3": {
          "t": "Courier screen",
          "d": "“My deliveries”, statuses and location — from a phone."
        },
        "b4": {
          "t": "Cash under control",
          "d": "See how much cash each courier holds; handover to the register in one click."
        },
        "f1": "Address check by zone",
        "f2": "Courier assignment",
        "f3": "Delivery status for the guest",
        "f4": "Courier cash handover",
        "f5": "Delivery report",
        "who": "For venues with their own couriers."
      },
      "reservations": {
        "title": "Table reservations",
        "tagline": "Reservations on the register and in ERP: the table is marked as reserved in advance — nobody seats guests in someone else's spot.",
        "b1": {
          "t": "Hall with reservations",
          "d": "See which tables are busy, free and reserved."
        },
        "b2": {
          "t": "No overlaps",
          "d": "Overlapping reservations for one table can't be created."
        },
        "b3": {
          "t": "“Reserved” an hour ahead",
          "d": "The table is marked automatically before guests arrive."
        },
        "b4": {
          "t": "Guest history",
          "d": "Reservations link to the customer card."
        },
        "f1": "Reservations from the register and ERP",
        "f2": "Number of guests and a comment",
        "f3": "Reschedule and cancel",
        "f4": "Works on the register offline too",
        "f5": "Daily reservation list",
        "who": "For restaurants and cafés where tables are booked in advance."
      },
      "analytics_pro": {
        "title": "Advanced analytics",
        "tagline": "ABC analysis, menu engineering, food cost and a load heatmap — see which dishes feed the business and which drag it down.",
        "b1": {
          "t": "Menu engineering",
          "d": "Stars, plowhorses, puzzles and dogs: what to promote, rework or remove."
        },
        "b2": {
          "t": "ABC analysis",
          "d": "Which 20% of items bring 80% of revenue and margin."
        },
        "b3": {
          "t": "Food cost and labor cost",
          "d": "Product and labor costs by day and category."
        },
        "b4": {
          "t": "Heatmap",
          "d": "Load by weekday and hour — shifts that match real guest flow."
        },
        "f1": "ABC by revenue, margin, quantity, products and guests",
        "f2": "Menu matrix",
        "f3": "Prime cost and revenue per labor hour",
        "f4": "Branch comparison",
        "f5": "CSV export for Excel",
        "who": "For owners and managers who make decisions based on numbers."
      },
      "telegram": {
        "title": "Owner's Telegram bot",
        "tagline": "Daily revenue, stock, supplier payments and alerts — right in Telegram, wherever you are.",
        "b1": {
          "t": "Daily report",
          "d": "Every evening — revenue, checks, average check, top dishes."
        },
        "b2": {
          "t": "Important things instantly",
          "d": "Refunds, shift closing, “running low in stock”."
        },
        "b3": {
          "t": "/today command",
          "d": "The day's results on request in one message."
        },
        "b4": {
          "t": "Everyone gets their own",
          "d": "An employee gets only what their permissions allow."
        },
        "f1": "Daily report per branch",
        "f2": "Shift and refund notifications",
        "f3": "Stock: running low and expiring",
        "f4": "Supplier payments",
        "f5": "Connect with one link",
        "who": "For owners and managers who want to keep their finger on the pulse."
      },
      "qr_ordering": {
        "title": "QR code ordering",
        "tagline": "The guest scans the QR on the table, picks dishes and sends the order — it appears on the register and in the kitchen at once. Less waiting, more orders.",
        "b1": {
          "t": "No waiting for a waiter",
          "d": "Guests order when they're ready — and order more often."
        },
        "b2": {
          "t": "Straight to the kitchen",
          "d": "The order goes to the kitchen screen automatically."
        },
        "b3": {
          "t": "Call a waiter and the bill",
          "d": "Buttons on the guest's phone — a notification on the register."
        },
        "b4": {
          "t": "Order status",
          "d": "The guest sees the dish is being prepared."
        },
        "f1": "Printable QR for every table",
        "f2": "Dish variants and modifiers",
        "f3": "Add to the same bill",
        "f4": "Order spam protection",
        "f5": "Notifications for waiters",
        "who": "For cafés and restaurants with table service."
      },
      "debts": {
        "title": "Guest debts",
        "tagline": "Sell “on credit” to regulars and company employees — with a limit, due date and repayment at the register. No notebooks.",
        "b1": {
          "t": "Limit per guest",
          "d": "The register won't let the credit limit be exceeded."
        },
        "b2": {
          "t": "Repayment at the register",
          "d": "In cash through the shift; the debt closes itself, oldest first."
        },
        "b3": {
          "t": "Overdue report",
          "d": "Who owes, how much and for how long."
        },
        "b4": {
          "t": "Adjustments and write-offs",
          "d": "Everything with a reason and in the log."
        },
        "f1": "Pay “on credit” at the register",
        "f2": "Repayment in parts",
        "f3": "Debt aging",
        "f4": "History for each guest",
        "f5": "Writing off bad debt",
        "who": "For venues with regular guests and corporate customers."
      }
    }
  },
  "invSettings": {
    "title": "Stock settings",
    "description": "Rules for all of the company's warehouses.",
    "expiry": "Expiry dates",
    "blockExpired": "Don't sell from expired batches",
    "blockExpiredHint": "Sales use fresh batches first; expired ones only if nothing else is left, and they wait to be written off",
    "warningDays": "Warn, days ahead",
    "warningDaysHint": "Batches expiring within this period appear in “Expiring soon” and in the morning notification",
    "production": "Production",
    "explode": "No semi-finished product — deduct raw materials",
    "explodeHint": "If there isn't enough ready semi-finished product, a sale deducts raw materials by its recipe. Turn off — the semi-finished product goes negative, showing it wasn't prepared",
    "safety": "Buffer for the production plan forecast",
    "safetyHint": "How many percent above average usage to make",
    "nothing": "Settings appear with the “Stock (advanced)” or “Production” add-ons."
  },
  "locations": {
    "title": "Storage locations",
    "short": "Location",
    "description": "Warehouse “{{name}}”: shelves, fridges, zones",
    "placeholder": "E.g.: Fridge #1",
    "name": "Location name",
    "add": "Add",
    "empty": "No locations yet",
    "emptyHint": "Add shelves and fridges — it's handy to count stock by them.",
    "products": "Products: {{count}}",
    "deleteTitle": "Delete location “{{name}}”?",
    "deleteHint": "Products stay in the warehouse without a location.",
    "hint": "Assign a product to a location in “Stock”: the “Location” column.",
    "all": "All locations",
    "pick": "Choose a location",
    "countHint": "Products assigned to this location will be counted"
  },
  "purchaseRequests": {
    "tabRequests": "Requests",
    "tabSuggest": "What to order",
    "suggest": {
      "purchaseComment": "From recommendations: usage and stock",
      "coverDays": "Buy for",
      "days": "{{count}} d",
      "history": "Look at usage",
      "lastDays": "for {{count}} days",
      "safety": "Buffer",
      "showAll": "Show everything with usage",
      "how": "Usage over {{history}} days (sales by recipe cards, write-offs, production) → daily forecast weighted by the last week → for {{cover}} days +{{safety}}% buffer, plus minimum stock, minus stock on hand and what is already requested.",
      "summaryMoney": "We recommend ordering {{count}} items, about {{sum}}",
      "summary": "We recommend ordering {{count}} items",
      "summaryHint": "Tick what you need, adjust quantities and create a request or a purchase right away. The amount is based on the last purchase price.",
      "selectAll": "Select all",
      "lastPurchase": "Bought {{date}}",
      "stock": "In stock",
      "daysLeft": "lasts ~{{n}} d",
      "daily": "Daily usage",
      "trendUp": "week: +{{pct}}%",
      "trendDown": "week: −{{pct}}%",
      "pending": "Already requested",
      "order": "Order",
      "estimate": "Approx.",
      "why": "Why",
      "reasons": {
        "negative": "Negative",
        "below_min": "Below minimum",
        "runs_out": "Running out",
        "low_data": "Little data"
      },
      "empty": "Nothing to order yet",
      "emptyHint": "Usage is calculated from sales with recipe cards and write-offs. Set a minimum stock on the product card — we'll tell you when to restock.",
      "toRequest": "Create request"
    },
    "title": "Purchase requests",
    "description": "Staff write what needs to be bought — the manager approves, buys from the request or rejects it. You can see who wrote and decided, and when.",
    "new": "New request",
    "newHint": "What and how much to buy. Pick a product from the catalog or just type a name.",
    "send": "Send request",
    "addLines": "Add at least one line with a quantity",
    "saved": "Request saved",
    "created": "Request #{{n}} sent",
    "editTitle": "Request #{{n}}: editing",
    "what": "What to buy",
    "whatPlaceholder": "Product or name",
    "addAsText": "Add “{{name}}” without the catalog",
    "lineNote": "Line note",
    "lineNotePlaceholder": "Note: brand, fat content, size…",
    "priority": "Urgency",
    "priorities": {
      "normal": "Normal",
      "urgent": "Urgent"
    },
    "neededBy": "Needed by",
    "neededByShort": "Needed by {{date}}",
    "comment": "Note",
    "commentHint": "Why and for which event, where best to buy",
    "commentPlaceholder": "E.g.: for Saturday's banquet, milk is running out",
    "rejectReason": "Reason for rejection",
    "rejectReasonRequired": "Enter the reason for rejection",
    "decisionNote": "Note for the author",
    "done": {
      "approve": "Request #{{n}} approved",
      "reject": "Request #{{n}} rejected",
      "purchased": "Request #{{n}} closed — bought"
    },
    "decision": {
      "approve": "Approve request #{{n}}?",
      "reject": "Reject request #{{n}}?",
      "purchased": "Mark request #{{n}} as bought?"
    },
    "decisionHint": {
      "approve": "The author will be notified. You can buy right away — the “Create purchase” button.",
      "reject": "The author will see the reason.",
      "purchased": "For purchases not posted to stock. To receive goods into stock — “Create purchase”."
    },
    "actions": {
      "approve": "Approve",
      "reject": "Reject",
      "purchased": "Bought",
      "cancel": "Withdraw",
      "makePurchase": "Create purchase"
    },
    "cancelTitle": "Withdraw request #{{n}}?",
    "history": {
      "created": "Created by",
      "updated": "Changed by",
      "approved": "Approved by",
      "rejected": "Rejected by",
      "purchased": "Bought by",
      "cancelled": "Withdrawn by"
    },
    "titleN": "Purchase request #{{n}}",
    "purchaseLink": "Purchase of {{date}} for {{sum}}",
    "commentBy": "Note from {{name}}",
    "rejectedTitle": "Rejected: {{name}}",
    "noteFrom": "Note from {{name}}",
    "notInCatalog": "not in catalog",
    "statuses": {
      "submitted": "Awaiting decision",
      "approved": "Approved",
      "purchased": "Bought",
      "rejected": "Rejected",
      "cancelled": "Withdrawn"
    },
    "pending": "Awaiting decision: {{count}}",
    "pendingHint": "Staff are waiting for an answer — approve, buy or reject.",
    "show": "Show",
    "approvedCount": "Approved and waiting to be bought: {{count}}",
    "approvedHint": "Open a request and click “Create purchase” — the lines fill in automatically.",
    "scope": "Whose requests",
    "scopeAll": "All",
    "scopeMine": "Mine",
    "search": "Search by item or note",
    "author": "Written by",
    "empty": "No requests yet",
    "emptyHint": "Noticed something running out? Write a request — the manager will see it right away.",
    "purchaseComment": "From purchase request #{{n}}",
    "purchaseFor": "Purchase for request #{{n}} ({{name}})",
    "textLinesHint": "Not in the catalog — add manually: {{lines}}"
  },
  "requests": {
    "title": "Stock requests",
    "description": "A branch orders goods from the central warehouse, the warehouse ships them as a transfer, the branch receives them.",
    "new": "New request",
    "newHint": "What you need for your warehouse and how much. The supplying warehouse will be notified.",
    "send": "Send request",
    "supplier": "From which warehouse",
    "supplierHint": "Usually the chain's central warehouse",
    "target": "To which warehouse",
    "neededBy": "Needed by",
    "commentPlaceholder": "E.g.: for the weekend, a banquet is coming",
    "pickSupplier": "Choose the supplying warehouse",
    "created": "Request #{{n}} sent: {{wh}}",
    "titleN": "Request #{{n}}",
    "ship": "Ship",
    "reject": "Reject",
    "cancel": "Withdraw",
    "shippedToast": "Request #{{n}} shipped — goods in transit",
    "rejectTitle": "Reject request #{{n}}?",
    "rejectHint": "The branch will see the reason.",
    "rejectReason": "Reason for rejection",
    "openTransfer": "Transfer #{{n}}",
    "transferN": "Transfer #{{n}}",
    "neededByShort": "Needed by {{date}}",
    "rejected": "Rejected",
    "shipHint": "Check the quantities: you can ship less than ordered, or 0 if out of stock. A transfer “in transit” will be created.",
    "ordered": "Ordered",
    "ourStock": "In our stock",
    "toShip": "Ship",
    "shipped": "Shipped",
    "createdBy": "Created: {{name}}, {{at}}",
    "decidedBy": "Decision: {{name}}, {{at}}",
    "statuses": {
      "submitted": "Awaiting shipment",
      "shipped": "Shipped",
      "received": "Received",
      "rejected": "Rejected",
      "cancelled": "Withdrawn"
    },
    "incoming": "Requests to your warehouse: {{count}}",
    "incomingHint": "Branches are waiting for goods — ship or reject.",
    "dirOut": "Our requests",
    "dirIn": "To our warehouse",
    "empty": "No requests yet",
    "emptyHint": "Order goods from the central warehouse — they'll arrive as a transfer."
  },
  "conversions": {
    "title": "Breakdown & assembly",
    "description": "Breakdown: carcass → tenderloin, meat, bones. Assembly: several items → a set. Cost is split between the outputs.",
    "new": "Breakdown or assembly",
    "post": "Post",
    "type": "Operation",
    "types": {
      "disassembly": "Breakdown",
      "assembly": "Assembly"
    },
    "disHint": "One product in — several out. The input cost is split by shares; without shares — in proportion to the outputs' purchase price (or quantity).",
    "asmHint": "Several products in — one out. Its cost = the sum of the inputs.",
    "template": "Template",
    "pickTemplate": "Fill from template",
    "inputDis": "What we break down",
    "inputAsm": "What we assemble from",
    "outputDis": "What we got",
    "outputAsm": "What we assembled",
    "byShares": "Set cost shares",
    "share": "Share",
    "sharesSum": "Shares total: {{pct}}%",
    "autoHint": "Shares are calculated automatically: by the outputs' purchase price, or by quantity if there's none.",
    "preview": "Estimate: {{sum}} at the last purchase price",
    "fill": "Fill in the input and output",
    "shares100": "Shares must total 100%",
    "doneDis": "Breakdown posted",
    "doneAsm": "Assembly posted",
    "tplName": "Template name, e.g. “Beef carcass”",
    "saveTemplate": "Save as template",
    "tplFill": "Enter the template name and lines",
    "tplSaved": "Template saved",
    "templates": "Templates",
    "useTemplate": "Post from template",
    "tplDeleteTitle": "Delete template “{{name}}”?",
    "deleteTitle": "Cancel the operation?",
    "deleteHint": "The input returns to stock and the outputs are deducted. If the outputs were already used, cancelling will fail.",
    "cancelDoc": "Cancel",
    "dist": {
      "share": "By shares",
      "price": "By purchase price",
      "qty": "By quantity"
    },
    "input": "Input",
    "output": "Output",
    "unitCost": "Unit cost",
    "search": "Product or comment",
    "what": "What → into what",
    "empty": "No operations yet",
    "emptyHint": "Break down a carcass or assemble a gift set — stock and costs update automatically."
  },
  "help": {
    "title": "Help center",
    "description": "How to set up and use every Coca feature — {{count}} articles",
    "search": "Search the help center",
    "searchPlaceholder": "E.g.: how to post a purchase, Z report, recipe…",
    "results": "Found: {{count}} for “{{q}}”",
    "noResults": "Nothing found",
    "noResultsHint": "Try other words or write to support — we'll answer.",
    "popular": "Where to start",
    "videos": "Video lessons",
    "videosHint": "Short clips showing how it is done on screen",
    "video": "Video",
    "sections": "Help sections",
    "allArticles": "All articles ({{count}})",
    "contents": "Help contents",
    "breadcrumbs": "Path",
    "inPlan": "In your plan: {{name}}",
    "notInPlan": "Not connected: {{name}}",
    "noPermission": "Your role has no access",
    "openSection": "Open section",
    "howToConnect": "How to connect",
    "related": "Related articles",
    "notFound": "Didn't find an answer?",
    "notFoundHint": "Describe your question — support will reply right in the app.",
    "askSupport": "Write to support",
    "hint": "Hint",
    "more": "More in the help center",
    "aboutSection": "Help for this section",
    "ruOnly": "The help center is in Russian for now. Translations are coming in upcoming updates."
  },
  goals: {
    title: "Goals & achievements",
    description: "Goals for the business, branch and each employee, a leaderboard and team achievements. Completion is checked automatically every hour.",
    myTitle: "My goals",
    myDescription: "Your goals, achievements and level. Progress counts paid orders.",
    tabs: {
      goals: "Goals",
      leaderboard: "Leaderboard",
      achievements: "Achievements",
    },
    add: "Set a goal",
    edit: "Edit goal",
    scan: "Check now",
    scanResult: "Goals reached: {{goals}}, new achievements: {{achievements}}",
    empty: "No goals yet",
    emptyHint: "Set a goal for daily revenue, average check or sales of a dish — the team will see the progress.",
    myEmpty: "No goals yet — your manager sets them",
    showOff: "Show disabled",
    titlePlaceholder: "E.g. Revenue 50,000 a day",
    pickEmployee: "Choose an employee",
    allBranches: "All branches",
    anyCategory: "Any category",
    itemFilterHint: "Empty — all dishes",
    rewardHint: "E.g. a 1,000 bonus",
    activeHint: "A disabled goal is not counted and employees don't see it",
    fields: {
      title: "Name",
      scope: "For whom",
      branch: "Branch",
      employee: "Employee",
      metric: "What we count",
      target: "Target",
      menuItem: "Dish",
      category: "Category",
      period: "Period",
      dateFrom: "From",
      dateTo: "To",
      reward: "Reward",
      points: "Points for completion",
      active: "Goal enabled",
    },
    targetHints: {
      revenue: "Total of paid orders for the period",
      orders: "Number of paid orders",
      avg_check: "Average order total — counted at the end of the period",
      items: "How many to sell",
      new_customers: "How many customers to add",
    },
    metrics: {
      revenue: "Revenue",
      orders: "Orders",
      avg_check: "Average check",
      items: "Dishes sold",
      new_customers: "New customers",
      points: "Points",
    },
    periods: {
      day: "Day",
      week: "Week",
      month: "Month",
      custom: "Custom dates",
    },
    periodNow: {
      day: "Today",
      week: "This week",
      month: "This month",
      custom: "{{from}} — {{to}}",
    },
    scopes: {
      company: "Whole company",
      branch: "Branch",
      employee: "Employee",
    },
    done: "Reached",
    off: "Disabled",
    progressOf: "{{value}} of {{target}}",
    rewardBadge: "Reward: {{reward}}",
    pointsBadge: "+{{count}} points",
    history: "Completion history",
    historyEmpty: "The goal hasn't been reached yet",
    deleteConfirm: "Delete goal “{{title}}”?",
    deleteHint: "Completion history and employees' points are kept.",
    rank: "Rank",
    employee: "Employee",
    value: "Result",
    points: "Points",
    level: "Level {{level}}",
    pointsTotal: "{{count}} points",
    leaderboardTitle: "Branch employee leaderboard",
    leaderboardEmpty: "No sales for the period yet",
    pointsAllTime: "All-time points: achievements and personal goals reached",
    myRank: "Leaderboard rank: {{rank}} of {{count}}",
    nextLevel: "To level {{level}}: {{count}} points",
    maxLevel: "Top level",
    earned: "Earned {{date}}",
    achievementsEarned: "Achievements: {{count}} of {{total}}",
    teamTitle: "Team",
    teamHint: "Employees' levels, points and achievements earned",
    teamEmpty: "No one has earned achievements yet",
    catalogTitle: "All achievements",
    catalogHint: "Awarded automatically for actions at the till, on shifts and in delivery — checked hourly",
    tiers: {
      bronze: "Bronze",
      silver: "Silver",
      gold: "Gold",
      platinum: "Platinum",
    },
    ach: {
      first_order: { title: "First order", hint: "Complete your first paid order" },
      orders_100: { title: "100 orders", hint: "Complete 100 paid orders" },
      orders_1000: { title: "1000 orders", hint: "Complete 1000 paid orders" },
      orders_5000: { title: "Floor legend", hint: "Complete 5000 paid orders" },
      items_500: { title: "500 dishes", hint: "Sell 500 items" },
      items_5000: { title: "5000 dishes", hint: "Sell 5000 items" },
      big_table: { title: "Big table", hint: "Serve an order for 10 or more guests" },
      first_shift: { title: "First shift", hint: "Work your first shift" },
      shifts_50: { title: "50 shifts", hint: "Work 50 shifts" },
      shifts_200: { title: "200 shifts", hint: "Work 200 shifts" },
      clean_cash_10: { title: "Accurate till", hint: "Close 10 cash shifts with no discrepancy" },
      clean_cash_50: { title: "Flawless till", hint: "Close 50 cash shifts with no discrepancy" },
      customers_10: { title: "10 new customers", hint: "Add 10 customers to the database" },
      customers_100: { title: "100 new customers", hint: "Add 100 customers to the database" },
      deliveries_10: { title: "10 deliveries", hint: "Deliver 10 orders" },
      deliveries_100: { title: "100 deliveries", hint: "Deliver 100 orders" },
      deliveries_500: { title: "500 deliveries", hint: "Deliver 500 orders" },
      goal_first: { title: "First goal", hint: "Reach your first personal goal" },
      goals_10: { title: "10 goals", hint: "Reach 10 personal goals" },
      goals_50: { title: "50 goals", hint: "Reach 50 personal goals" },
      top_seller: { title: "Seller of the week", hint: "Highest revenue in the branch for a week" },
    },
  },
  mixedPay: {
    label: "Mixed",
    cash: "In cash",
    rest: "The rest",
    invalid: "Both parts must be greater than zero",
    partial: "Partially paid: {{paid}}. The second part failed — check and pay the rest.",
  },
  menuPacks: {
    title: "Menu packs",
    subtitle: "A menu for your format: dishes with photos and descriptions, products with purchase prices, semi-finished items and costed recipe cards",
    howTitle: "How it works",
    how: "Pick a pack for your format and browse the dishes. You buy it once, by invoice. After payment, load the whole pack or selected dishes into your menu: categories, items with photos, products, semi-finished items and published recipe cards appear. You can change prices and quantities later.",
    empty: "No menu packs yet",
    footer: "Costs are calculated with Bishkek purchase prices — after loading they are recalculated with your product prices.",
    open: "View",
    owned: "Purchased",
    counts: "{{items}} dishes · {{semis}} semi-finished · {{products}} products",
    state: {
      available: "Available",
      pending: "Awaiting payment",
      owned: "Purchased",
    },
    stat: {
      items: "dishes",
      semis: "semi-finished",
      products: "products",
      photos: "photos",
    },
    avgFoodCost: "Average food cost of the pack — {{pct}}%",
    fc: "food cost {{pct}}%",
    minutes: "{{n}} min",
    buy: "Buy for {{price}}",
    showInvoice: "Show invoice",
    ownedNow: "The pack is unlocked — you can load it into the menu",
    askOwner: "The owner or an administrator can buy the pack (“Subscription: manage” permission).",
    noPrice: "The pack isn't sold in your subscription currency yet — contact support.",
    pendingHint: "Invoice {{n}} is awaiting payment. The pack unlocks right after payment.",
    currencyHint: "Pack prices are in som — conversion for {{currency}} isn't set up, check the prices after loading.",
    imported: "Loaded {{n}} times",
    importAgain: "Load again",
    price: "Price",
    cost: "Cost",
    yield: "Yield",
    calories: "kcal",
    cookTime: "Cooking time",
    variants: "Sizes",
    modifiers: "Modifiers",
    allergens: "Allergens",
    semis: "Semi-finished items",
    semiOutput: "Yield {{qty}} {{unit}} · {{cost}}",
    photoCredit: "Photo: {{author}}, {{license}}",
    photosNote: "Photos — Wikimedia Commons (free licenses; author and license are shown on each dish). Costs use the pack's purchase prices.",
    units: {
      g: "g",
      ml: "ml",
      pcs: "pcs",
    },
    recipe: {
      title: "Recipe card",
      product: "Product",
      gross: "Gross",
      waste: "Waste",
      loss: "Loss",
      takeaway: "takeaway",
      instructions: "Preparation",
      locked: "Quantities, waste and preparation steps unlock after purchase.",
    },
    invoice: {
      title: "Invoice {{n}}",
      pack: "Menu pack “{{name}}”",
      bank: "Payment details",
      after: "The pack unlocks right after the invoice is paid. All invoices are in “Subscription”.",
      print: "Print invoice",
      all: "All invoices",
    },
    import: {
      open: "Load into menu",
      title: "Load “{{name}}”",
      submit: "Load ({{n}})",
      photos: "Dish photos",
      recipes: "Recipe cards, products and semi-finished items",
      recipesHint: "Products with purchase prices, semi-finished items and published recipe cards — costs are calculated right away",
      inactive: "Hide items until checked",
      inactiveHint: "Items are created switched off — turn them on in “Menu” once you check the prices.",
      repeatHint: "Items that already exist in the menu with the same name are skipped. Products, categories and modifier groups with the same name are reused.",
      done: "Items loaded: {{n}}",
      resultTitle: "Pack loaded",
      toMenu: "Open menu",
      skipped: "Already in the menu — skipped: {{n}}",
      counts: {
        items: "Items",
        categories: "New categories",
        products: "Products",
        semis: "Semi-finished",
        recipes: "Recipe cards",
        groups: "Modifier groups",
        photos: "Photos",
      },
    },
  },
  waiterZones: {
    title: "Waiters by hall",
    description: "Who serves which halls and tables: if a waiter is off shift, the next one gets the table right away; automatic distribution can be turned on.",
    tabs: {
      now: "Now",
      zones: "Zones",
      settings: "Settings",
    },
    add: "Add zone",
    edit: "Edit zone",
    empty: "No zones yet",
    emptyHint: "Create a zone: a hall or tables and waiters in order. New orders for these tables will go straight to the right waiter.",
    namePlaceholder: "Main hall",
    fields: {
      name: "Name",
      scope: "Serves",
      hall: "Hall",
      tables: "Tables",
      mode: "How to distribute",
      waiters: "Waiters",
      active: "Zone enabled",
    },
    scopes: {
      branch: "Whole branch",
      hall: "Hall",
      tables: "Specific tables",
    },
    modes: {
      priority: "By priority",
      round_robin: "In turn",
      least_loaded: "Least busy",
    },
    modeHints: {
      priority: "The table goes to the first waiter on the list who is on shift. If they are away — the second one, and so on.",
      round_robin: "Automatic: tables in turn — the next table goes to whoever has waited longest for one.",
      least_loaded: "Automatic: the table goes to whoever has the fewest open tables right now.",
    },
    pickHall: "Choose a hall",
    pickTables: "Choose tables",
    branchHint: "Fallback zone: used for tables without their own zone or when nobody from their zone is on shift.",
    orderHint: "Order matters: the first is the main waiter, the rest are backups in turn.",
    addWaiter: "Add waiter",
    moveUp: "Move up",
    moveDown: "Move down",
    activeHint: "A disabled zone takes no part in distribution.",
    table: "Table {{number}}",
    tablesList: "Tables: {{list}}",
    off: "Disabled",
    inactive: "Unavailable",
    onShift: "On shift",
    offShift: "Off shift",
    deleteConfirm: "Delete zone “{{name}}”?",
    deleteHint: "Tables already served by the zone's waiters stay with them.",
    orderRule: "A table goes to the first matching zone: “Specific tables” first, then “Hall”, then “Whole branch”. If nobody in a zone is on shift, the next zone is used.",
    noZonesNow: "No zones — orders stay with whoever opened them. Create a zone on the “Zones” tab.",
    notTracking: "Shifts are not tracked: all zone waiters count as present.",
    staffTitle: "Waiters",
    staffHint: "Who is on shift and how many open tables each has.",
    staffEmpty: "No waiters in zones and nobody has clocked in",
    openTables: "Open tables: {{count}}",
    servedBy: "Served by {{name}} · order #{{number}}",
    free: "Free",
    nextIs: "A new order goes to: {{name}} ({{zone}})",
    nextNobody: "Nobody right now — the order stays with whoever opens it",
    settings: {
      requireShift: "Take work shifts into account",
      requireShiftHint: "Only those who have clocked in and are not on a break get tables.",
      reassignOnLeave: "Hand over tables of those who leave",
      reassignOnLeaveHint: "When a waiter closes their shift, their open tables go to the next one in the zone right away.",
      assignStaffOrders: "Distribute cashier orders",
      assignStaffOrdersHint: "A table order opened by a cashier or an administrator goes straight to the zone's waiter.",
    },
  },
};
